// lib/index.ts
import axios from "axios";

// lib/Button.tsx
import { useState } from "react";

// esbuild-css-modules-plugin-namespace:C:\Users\silvi\AppData\Local\Temp\tmp-19948-1Wsk2jM0o5RW\lightbox.js-react\lib\Button.module.css.js
var digest = "53abe3f09607da4b001a6ed45f4cdeb9729bd51d202ccc73ee19cc8899562a95";
var css = `._button_1htbf_1 {
  border-radius: 8px;
  border: 1px solid transparent;
  padding: 0.6em 1.2em;
  font-size: 1em;
  font-weight: 500;
  font-family: inherit;
  background-color: #1a1a1a;
  cursor: pointer;
  transition: border-color 0.25s;
  font-family: Inter, system-ui, Avenir, Helvetica, Arial, sans-serif;
  line-height: 1.5;
  font-weight: 400;

  color-scheme: dark;
  color: rgba(255, 255, 255, 0.87);
  background-color: #242424;

  font-synthesis: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-text-size-adjust: 100%;
}
._button_1htbf_1:hover {
  border-color: #646cff;
}
._button_1htbf_1:focus,
._button_1htbf_1:focus-visible {
  outline: 4px auto -webkit-focus-ring-color;
}

._primary_1htbf_33 {
  background-color: #646cff;
  color: #fff;
  border-color: #646cff;
}
._primary_1htbf_33:hover {
  background-color: #4f4fff;
  border-color: #4f4fff;
}

._secondary_1htbf_43 {
  background-color: #f2f2f2;
  color: #1a1a1a;
  border-color: #f2f2f2;
}
._secondary_1htbf_43:hover {
  background-color: #e6e6e6;
  border-color: #e6e6e6;
}

._small_1htbf_53 {
  padding: 0.4em 0.8em;
  font-size: 0.8em;
}

._medium_1htbf_58 {
  padding: 0.6em 1.2em;
  font-size: 1em;
}

._large_1htbf_63 {
  padding: 0.8em 1.6em;
  font-size: 1.2em;
}
`;
(function() {
  if (typeof document === "undefined") {
    return;
  }
  if (!document.getElementById(digest)) {
    var el = document.createElement("style");
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
var Button_module_css_default = { "button": "_button_1htbf_1", "primary": "_primary_1htbf_33", "secondary": "_secondary_1htbf_43", "small": "_small_1htbf_53", "medium": "_medium_1htbf_58", "large": "_large_1htbf_63" };

// lib/Button.tsx
import { jsxs } from "react/jsx-runtime";
function Button({ type, size }) {
  let [count, setCount] = useState(0);
  return /* @__PURE__ */ jsxs(
    "button",
    {
      onClick: () => setCount((count2) => count2 + 1),
      className: Button_module_css_default.button + " " + (type === "secondary" ? Button_module_css_default.secondary : Button_module_css_default.primary) + " " + (size === "small" ? Button_module_css_default.small : size === "medium" ? Button_module_css_default.medium : Button_module_css_default.large),
      children: [
        "Count is ",
        count
      ]
    }
  );
}

// lib/SlideshowLightbox.tsx
import * as React from "react";
import { useState as useState3, useEffect as useEffect2, useRef as useRef2, useCallback as useCallback2, useImperativeHandle } from "react";
import { motion, AnimatePresence, MotionGlobalConfig } from "framer-motion";

// esbuild-css-modules-plugin-namespace:C:\Users\silvi\AppData\Local\Temp\tmp-19948-k54deyDZgLBZ\lightbox.js-react\lib\SlideshowLightbox.module.css.js
var digest2 = "4e1e510a0801fe474ebc88b80b3714ad4f41a515aa5028e44ade4b8b6fa1f816";
var css2 = `._lightboxjs_y23g1_1 {
    margin: 0;
    padding: 0;
  }
  
  ._lightboxjs_y23g1_1 * {
    box-sizing: border-box;
  }
  
  /* .lightboxjs img,
  .lightboxjs svg,
  .lightboxjs video {
    display: block;
    vertical-align: middle;
    height: auto;
    max-width: 100%;
  } */
  
  ._slideshowContainer_y23g1_37 {
    background-color: black;
    height: 100vh;
    width: 100vw;
    position: fixed;
    top: 0;
    left: 0;
  }
  
  ._slideshowBtn_y23g1_55 {
    padding-bottom: 2px;
  }
  
  ._closeIcon_y23g1_63:hover,
  ._closeIcon_y23g1_63:focus,
  ._iconsHeader_y23g1_67 svg:hover,
  ._iconsHeader_y23g1_67 svg:focus,
  ._prev1_y23g1_71 span:hover,
  ._next1_y23g1_73:hover,
  ._icon_y23g1_67:hover {
    text-decoration: none;
    cursor: pointer;
    /* color: rgb(230, 230, 230); */
  }
  
  /* On hover, add a black background color with a little bit see-through */
  ._prevIcon_y23g1_89:hover,
  ._nextIcon_y23g1_91:hover {
    background-color: rgba(0, 0, 0, 0.8);
    color: rgb(230, 230, 230);
  }
  
  ._show_y23g1_101 {
    display: flex;
  }
  
  ._displayHidden_y23g1_109 {
    display: none;
  }
  
  ._thumbnail_y23g1_117 {
    opacity: 1;
    transition: all 0.3s;
    cursor: pointer;
    position: relative;
  }
  
  img._hoverShadow_y23g1_131 {
    transition: 0.3s;
  }
  
  ._hoverShadow_y23g1_131:hover {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  }
  
  ._next1_y23g1_73 {
    right: 1%;
    padding-left: 2vw;
    padding-right: 3vw;
  }
  
  ._prev1_y23g1_71 {
    left: 2%;
    padding-right: 2vw;
  }
  
  
  ._thumbnails_y23g1_171 {
    transition: border 0.3s;
  }
  
  ._thumbnail_y23g1_117 {
    display: inline;
  }
  
  ._thumbnailsWithCaption_y23g1_187 {
    width: 90%;
  }
  
  ._navigationDots_y23g1_195 {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  
  /* Mobile screens */
  @media screen and (min-width: 20em) {
    ._imageSlide_y23g1_211 {
      height: 67vw;
      width: 60%;
    }
  
    ._thumbnailsOuterContainer_y23g1_221 {
      position: fixed;
      bottom: 5%;
      width: 100vw;
      /* width: 100%; */
    }
  
    ._hideControlsBar_y23g1_235 ._slideshowImg_y23g1_235 {
      height: 100vh;
    }
  
  
    ._hideControlsBar_y23g1_235 ._slideshowInnerContainer_y23g1_245 {
      top: 0;
    }
  
    ._thumbnail_y23g1_117 {
      width: 80px;
      max-width: 80px;
      height: 7vh;
    }
  
    ._videoThumbnailsOuterContainer_y23g1_265 {
      bottom: 2%;
    }
  
    ._imgTitleContainer_y23g1_273 {
      padding-bottom: 16px;
      width: 100vw;
    }
  
    ._thumbnails_y23g1_171 {
      margin-left: auto;
      margin-right: auto;
    }
  
    ._next1_y23g1_73 {
      right: 0.9%;
    }
  
    ._prev1_y23g1_71 {
      left: 1.5%;
    }
  }
  
  ._thumbnail_y23g1_117 {
    height: 5vh;
    border-radius: 6px;
    margin-right: 7px;
    object-fit: cover;
  }
  
  ._thumbnailsOuterContainer_y23g1_221 {
    position: absolute;
    bottom: 10%;
    height: 5vh;
    width: 100vw;
    z-index: 10000000;
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
  }
  
  ._thumbnailsOuterContainerMetadata_y23g1_349 {
    width: 78vw;
  }
  
  ._videoThumbnailsOuterContainer_y23g1_265 {
    bottom: 5%;
  }
  
  ._thumbnailsAndCaption_y23g1_365 {
    height: 19vh;
  }
  
  ._htmlVideoOuterContainer_y23g1_373 video {
    height: 100%;
    max-height: 70vh;
    width: 100%;
  }
  
  ._caption_y23g1_385 {
    position: absolute;
    bottom: 14%;
    width: 100vw;
    z-index: 10000000;
    margin-top: 10px;
    margin-left: auto;
    margin-right: auto;
  }
  
  ._galleryImg_y23g1_405 {
    cursor: pointer;
    margin: 0.2em;
  }
  
  ._modalContainer_y23g1_415 {
    width: 100vw;
    height: 100%;
    max-height: 100%;
    direction: ltr;
    overflow: hidden;
    touch-action: none;
    padding: 0;
    overflow-y: hidden;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000000;
  }
  
  ._slideshowAnimContainer_y23g1_453 {
    height: 100%;
    max-height: 100%;
    direction: ltr;
    overflow: hidden;
    touch-action: none;
    padding: 0;
    overflow-y: hidden;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    /* position: fixed; */
    top: 0;
    left: 0;
    z-index: 1000000;
  }
  
  ._fullScreenContainer_y23g1_489 img {
    height: 100vh;
    max-width: 100%;
    max-height: 100%;
  }
  
  ._imageInnerContainer_y23g1_501 img {
    height: 80vh;
    max-width: 100%;
    max-height: 100%;
  }
  
  ._imageInnerContainer_y23g1_501 {
    position: fixed;
    display: flex;
    flex-direction: column;
    justify-content: center;
    top: 0;
    align-content: center;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    z-index: 1000000;
  }
  
  ._magnifyWrapper_y23g1_539 {
    margin-bottom: 3em;
    margin-left: auto;
    margin-right: auto;
  }
  
  ._slideshowInnerContainer_y23g1_245 {
    position: fixed;
    display: flex;
    flex-direction: column;
    justify-content: center;
    transition: top 0.2s ease-in-out 0s;
    top: 10%;
    align-content: center;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    z-index: 1000000;
  }
  
  ._slideshowInnerContainerImgMetadata_y23g1_579 {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  
  ._slideshowInnerVideoContainer_y23g1_593 {
    top: 6%;
  }
  
  ._slideshowInnerContainerThumbnails_y23g1_601 {
    top: 12%;
  }
  
  ._hideControlsBar_y23g1_235  {
    top: 0;
  }
  
  ._fullScreenContainer_y23g1_489 {
    top: 0;
  }
  
  ._lightboxContainer_y23g1_625 {
    width: 100vw;
    height: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  ._next1_y23g1_73,
  ._prev1_y23g1_71 {
    top: calc(50% - 20px);
    position: absolute;
    display: flex;
    transition: all 0.2s;
    justify-content: center;
    align-items: center;
    padding-bottom: 2vh;
    padding-top: 2vh;
    user-select: none;
    cursor: pointer;
    font-weight: bold;
    border-radius: 30px;
    width: 40px;
    height: 40px;
    font-size: 18px;
    z-index: 10000000;
  }
  
  
  
  ._next1_y23g1_73:hover,
  ._prev1_y23g1_71:hover {
    color: rgb(230, 230, 230);
  }
  
  ._slideshowAnimImg_y23g1_697 {
    position: absolute;
    max-width: 100vw;
  }
  
  ._controls_y23g1_707 {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  
  ._iconsHeader_y23g1_67 {
    color: white;
    position: absolute;
    display: flex;
    flex-direction: row;
    /* align-items: center;
      justify-content: center; */
    cursor: pointer;
    top: 10px;
    right: 45px;
    z-index: 999999999;
    /* padding: 0.14vw; */
  }
  
  ._ytVideo_y23g1_747 {
    aspect-ratio: 16 / 9;
    height: 65vh;
    width: 100%;
  }
  
  ._videoOuterContainer_y23g1_759 {
    width: 65%;
    margin-left: auto;
    margin-right: auto;
    height: 60vh;
    max-height: 65vh;
  }
  
  ._htmlVideoOuterContainer_y23g1_373 {
    width: 80%;
    margin-left: auto;
    margin-right: auto;
  }
  
  ._customVideoContainer_y23g1_787, ._customEmbedContainer_y23g1_787 {
    margin-left: auto;
    margin-right: auto;
  }
  
  ._videoIconsHeader_y23g1_797 {
    position: fixed;
    top: 4%;
    right: 3%;
  }
  
  ._lightbox_y23g1_1 ._iconsHeader_y23g1_67 svg {
    transition: 0.3s all;
  }
  
  ._iconsHeader_y23g1_67 svg:active {
    transform: scale(0.97);
  }
  
  ._imgTitle_y23g1_273 {
    text-align: center;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
  }
  
  ._iconsHeader_y23g1_67 svg {
    margin-left: 0.6em;
    padding: 0.2em;
    transition: all 0.1s;
    /* width: 32px;  */
    /* font-size: 18px; */
    line-height: 16px;
    vertical-align: baseline;
  }
  
  ._icon_y23g1_67 {
    /* width: 32px;  */
  }
  
  @media screen and (min-width: 6em) {
    ._iconsHeader_y23g1_67 {
      top: 3%;
    }
  
    ._slideshowAnimContainer_y23g1_453 {
      width: 100vw;
    }
  
    ._iconsHeader_y23g1_67 svg {
      /* width: 34px;  */
      padding-right: 0.3em;
    }
  
    ._lightboxjs_y23g1_1 img {
      cursor: pointer;
    }
  
    ._thumbnail_y23g1_117 {
      height: 9vh;
      /* width: 22vw; */
    }
  
    ._next1_y23g1_73 {
      top: calc(48% - 20px);
    }
  
    ._prev1_y23g1_71 {
      top: calc(48% - 20px);
  
    }
  
  
  }
  
  @media screen and (min-width: 39em) {
    ._slideshowAnimContainer_y23g1_453 {
      width: 100vw;
    }
  
    ._slideshowInnerContainer_y23g1_245 {
      width: 100vw;
      height: 95vh;
      position: absolute;
    }
  
    ._imgTitleContainer_y23g1_273 {
      padding-bottom: 0px;
    }
  
    ._next1_y23g1_73 {
      right: 0.7%;
    }
  
    /* .hideControlsBar .slideshow_img {
      height: 70vh;
  
    }
  
    .hideControlsBar {
      top: 10%;
    } */
  
  
  
    ._fullScreenContainer_y23g1_489 {
      width: 80vw;
      height: 100vh;
    }
  
    ._fullScreenContainer_y23g1_489 img {
      height: 100vh;
    }
  
    ._thumbnails_y23g1_171 {
      margin-top: 0.6em;
    }
  
    ._thumbnail_y23g1_117 {
      /* height: 8vh; */
      width: 80px;
      max-width: 80px;
    }
  
    ._iconsHeader_y23g1_67 svg {
      /* width: 32px; 
        font-size: 32px; */
    }
  
    ._prev1_y23g1_71 {
      left: 2.7%;
      padding-right: 2vw;
    }
  }
  
  /* Desktop screens */
  @media screen and (min-width: 42em) {
    ._imageSlide_y23g1_211 {
      height: 70vh;
      width: 80vw;
    }
  
    ._slideshowImgFullscreen_y23g1_1071 {
      display: grid;
      width: 92vw;
      place-items: start;
      margin-left: auto;
      margin-right: auto;
      scrollbar-gutter: stable both-edges;
    }
  
    ._slideshowInnerContainer_y23g1_245 img {
      margin-top: 0vh;
      /* width: 70vw; */
    }
  
    ._fullScreenContainer_y23g1_489 img {
      width: 80vw;
    }
  
    ._slideshowInnerContainerFullScreen_y23g1_1107 {
      top: 0%;
    }
  
    ._fullScreenLightboxImg_y23g1_1115 {
      margin-left: auto;
      margin-right: auto;
      height: 100vh;
    }
  
    ._slideshowInnerContainerFullScreen_y23g1_1107 {
      height: 100vh;
      width: 100vw;
      position: absolute;
    }
  
    ._slideshowInnerContainerFullScreen_y23g1_1107 img {
      object-fit: contain;
    }
  
    ._thumbnails_y23g1_171 {
      scrollbar-width: none;
      -ms-overflow-style: none;
      margin-top: 1.1em;
    }
  
    ._thumbnails_y23g1_171::-webkit-scrollbar {
      display: none; /* Safari and Chrome */
    }
  
    ._opacity-fade_y23g1_1167 {
      transition: opacity 0.3s;
      -webkit-transition: opacity 0.3s;
      opacity: 1;
    }
  
    ._thumbnailsOuterContainer_y23g1_221 {
      margin-top: 0.1em;
      padding-top: 0.3em;
      height: 5vh;
      bottom: 11%;
    }
  
    ._thumbnail_y23g1_117,
    ._imageSliderThumbnails_y23g1_1195 img {
      height: 10vh;
      /* width: 7em; */
    }
  
    ._slideshowAnimContainer_y23g1_453 {
      width: 100vw;
    }
  
    ._slideshowInnerContainer_y23g1_245 {
      width: 100vw;
      height: 95vh;
    }
  
    ._hideControlsBar_y23g1_235 {
      height: 100vh;
    }
  
    ._fullScreenContainer_y23g1_489 {
      width: 80vw;
      height: 100vh;
    }
  
    ._iconsHeader_y23g1_67 svg {
      /* width: 37px;
        font-size: 34px; */
    }
  
    ._prev1_y23g1_71 {
      left: 2%;
      padding-right: 2vw;
    }
  
    ._next1_y23g1_73 {
      right: 0.4%;
    }
  
    
    ._slideshowImgMetadata_y23g1_1271 {
      width: 78vw;
    }
  
    ._prev1Metadata_y23g1_1279 {
      left: 1%;
    }
  
    ._navigationDots_y23g1_195 {
      gap: 8px;
    }
  }
  
  @media screen and (min-width: 53em) {
    
    ._slideshowImg_y23g1_235 {
      display: grid;
      width: 100vw;
      height: 70vh;
      place-items: start;
      /* margin-top: 7vh; */
    }
  
    ._hideControlsBar_y23g1_235 ._slideshowImg_y23g1_235, ._hideControlsBarAndCaption_y23g1_1317 ._slideshowImg_y23g1_235  {
      padding-top: 12vh;
    }

    ._fullScreenContainer_y23g1_489 ._slideshowImg_y23g1_235 {
      padding-top: 0vh;
    }
  
  
    ._lightboxImg_y23g1_1335 {
        /* height: 70vh; */
    }
  
    ._thumbnail_y23g1_117 {
      width: 95px;
      max-width: 80px;
    } 
  
    ._slideshowImgMetadata_y23g1_1271 {
      width: 78vw;
    }
  }
    
  
  @media screen and (min-width: 80em) {
    ._slideshowInnerContainer_y23g1_245 img {
      /* width: 60vw; */
    }
  
    ._fullScreenContainer_y23g1_489 img {
      width: 80vw;
    }
  }
  
  ._lightIcon_y23g1_1385,
  ._lightIcon_y23g1_1385 svg {
    background-color: white;
    color: black;
  }
  
  ._lightIcon_y23g1_1385:hover,
  ._lightIcon_y23g1_1385 svg:hover {
    background-color: white;
    color: black;
    fill: black;
  }
  
  ._darkIcon_y23g1_1411,
  ._darkIcon_y23g1_1411 svg {
    background-color: transparent;
    /* background-color: #151515; */
    color: silver;
    fill: silver;
  }
  
  ._darkIcon_y23g1_1411:hover,
  ._darkIcon_y23g1_1411 svg:hover {
    color: rgba(107, 107, 107, 0.8);
    fill: rgba(107, 107, 107, 0.8);
  }
  
  /* Header icons  */
  ._lightHeaderIcon_y23g1_1441 svg {
    background-color: white;
    color: black;
    fill: black;
  }
  
  ._lightHeaderIcon_y23g1_1441 svg:hover {
    background-color: white;
    color: rgb(24, 24, 24, 0.8);
    fill: rgb(24, 24, 24, 0.8);

  }
  
  ._darkHeaderIcon_y23g1_1467 svg {
    background-color: transparent;
    /* background-color: #151515; */
    color: #626b77;
    fill: #626b77;
  }
  
  ._darkHeaderIcon_y23g1_1467 svg:hover {
    color: rgba(99, 99, 99, 0.8);
    fill: rgba(99, 99, 99, 0.8);
  }
  
  ._magnifierImage_y23g1_1491 {
    object-fit: contain;
  }
  
  ._thumbnails_y23g1_171 ._active_y23g1_1499 {
    border: solid rgb(107, 133, 206) 2px;
  }
  
  ._inactiveThumbnailBorder_y23g1_1507 {
    border: solid transparent 2px;
  }
  
  ._thumbnails_y23g1_171 {
    width: 95%;
  }
  
  ._emblaThumbs_y23g1_1523 {
    --thumbs-slide-spacing: 2px; 
    /* --thumbs-slide-height: 9rem; */
    margin-top: var(--thumbs-slide-spacing);
  }
  
  @media screen and (max-width: 29em) {
    ._fullScreenContainer_y23g1_489 img {
      object-fit: cover;
    }
  
    ._emblaThumbs_y23g1_1523 {
      --thumbs-slide-spacing: 3px; 
      /* --thumbs-slide-height: 9rem; */
      margin-top: var(--thumbs-slide-spacing);
    }
  
    ._htmlVideo_y23g1_373 {
      margin-top: 5vh;
    }
  
    ._thumbnails_y23g1_171 {
      width: 98%;
    }
  
    ._thumbnail_y23g1_117 {
      width: 80px;
      max-width: 80px;
    }
  
    ._htmlVideoOuterContainer_y23g1_373 video {
      max-height: 65vh;
    }
  
    ._videoIconsHeader_y23g1_797 {
      position: fixed;
      top: 2%;
      right: 15px;
    }
  
    ._videoOuterContainer_y23g1_759 {
      width: 88%;
      margin-left: auto;
      margin-right: auto;
      height: 100%;
      max-height: 65vh;
    }
  
    ._htmlVideoOuterContainer_y23g1_373 {
      width: 94%;
      margin-left: auto;
      margin-right: auto;
    }
  
    ._iconsHeader_y23g1_67 {
      position: fixed;
      left: 115px;
    }
  
    ._slideshowInnerVideoContainer_y23g1_593 {
      top: 3%;
    }
  
    ._next1_y23g1_73,
    ._prev1_y23g1_71 {
      padding-bottom: 2vh;
      padding-top: 2vh;
    }
  
    ._next1_y23g1_73 {
      padding-left: 4vw;
    }
  
    ._prev1_y23g1_71 {
      padding-right: 4vw;
    }
  
    ._iconsHeader_y23g1_67 {
      /* font-size: 28px; */
    }
  
  
  }
  
  @media screen and (max-width: 53em) {
    ._slideshowImg_y23g1_235 {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      width: 100vw;
      height: 70vh;
    }
  
    ._slideshowImg_y23g1_235 img {
      margin-left: auto;
      margin-right: auto;
    }
  
    ._slideshowImg_y23g1_235 {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      width: 100vw;
      height: 70vh;
    }
  
    ._slideshowInnerContainerFullScreen_y23g1_1107 {
      position: fixed;
      display: flex;
      flex-direction: column;
      justify-content: center;
      transition: top 0.2s ease-in-out 0s;
      top: 10%;
      align-content: center;
      margin-left: auto;
      margin-right: auto;
      text-align: center;
      z-index: 1000000;
    }
  
    ._containImg_y23g1_1767 {
      object-fit: contain;
    }
  
  }
  
  ._fullScreenContainer_y23g1_489 img {
    object-fit: cover;
  }
  
  ._thumbnails_y23g1_171 {
    text-align: center;
    white-space: nowrap;
  }
  
  ._reactTransformComponent_y23g1_1797 {
    margin-left: auto;
    margin-right: auto;
  }
  
  ._magnifierImage_y23g1_1491 {
    margin-left: auto;
    margin-right: auto;
  }
  
  /* CSS loader  */
  ._loader_y23g1_1819 {
    width: 44px;
    height: 44px;
    box-sizing: border-box;
  
    border-radius: 50%;
  
    display: inline-block;
    position: fixed;
    top: 50%;
    left: 50%;
    animation: _rotation_y23g1_1 1s linear infinite;
  }
  
  @keyframes _rotation_y23g1_1 {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  
  ._dayLoader_y23g1_1865 {
    border: 5px solid #626b77;
    border-bottom-color: transparent;
  }
  
  ._nightLoader_y23g1_1875 {
    border: 5px solid #fff;
    border-bottom-color: transparent;
  }
  
  ._lightboxImg_y23g1_1335 {
    max-height: 70vh;
    margin-left: auto;
    margin-right: auto;
  }
  
  ._controls_y23g1_707 button, ._closeButton_y23g1_1897, ._closeButtonRounded_y23g1_1897 {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    font-size: 16px;
  }
  
  ._controls_y23g1_707 svg {
    box-sizing: border-box;
  }
  
  ._closeButton_y23g1_1897 svg, ._closeButtonRounded_y23g1_1897 svg {
    box-sizing: border-box;
    font-size: 16px;
    padding-top: 0.5px;
  }
  
  ._closeButton_y23g1_1897 {
    padding-top: 3px;
  }
  
  ._closeButtonRounded_y23g1_1897 {
    cursor: pointer;
  
  }
  
  ._closeButtonRounded_y23g1_1897 svg {
    margin: 0;
    padding: 5px;
    background-color: black;
    border-color: transparent;
    border-radius: 28px;
  
  }
  
  ._thumbnailsAndCaption_y23g1_365 {
    bottom: 0%;
    height: 19vh;
    margin-top: 0em;
    width: 100vw;
  }
  
  ._thumbnailsWithCaption_y23g1_187 {
    margin-top: 0em;
  }
  
  ._slideImageAndCaption_y23g1_1991 {
    top: 7%;
  }
  
  ._slideImageAndCaption_y23g1_1991._hideControlsBar_y23g1_235 {
    top: 0;
  }
  
  ._slideshowAnimContainer_y23g1_453 {
    -ms-overflow-style: none;
    /* scrollbar-width: none;   */
  }
  ._thumbnails_y23g1_171::-webkit-scrollbar {
    display: none;
  }
  
  ._roundedBorder_y23g1_2023 {
    border-radius: 20px;
  }
  
  ._maxWidthFull_y23g1_2031 {
    max-width: 100%;
  }
  
  ._maxWidthWithoutMagnifier_y23g1_2039 {
    max-width: 80%;
  }
  
  @media screen and (max-width: 880px) {
    ._iconsHeader_y23g1_67 {
      position: fixed;
      right: 5%;
    }
  }
  
  @media screen and (max-width: 480px) {
    ._iconsHeader_y23g1_67 {
      position: fixed;
      left: 180px;
    }
  }
  
  @media screen and (max-width: 440px) {
    ._iconsHeader_y23g1_67 {
      position: fixed;
      left: 160px;
    }
  }
  
  @media screen and (max-width: 410px) {
    ._iconsHeader_y23g1_67 {
      position: fixed;
      left: 140px;
    }
  }
  
  @media screen and (max-width: 385px) {
    ._iconsHeader_y23g1_67 {
      position: fixed;
      left: 135px;
      /* top: 24px; */
    }
  }
  
  @media screen and (max-width: 365px) {
    ._iconsHeader_y23g1_67 {
      position: fixed;
      left: 90px;
    }
  }
  
  @media screen and (max-width: 345px) {
    ._iconsHeader_y23g1_67 {
      position: fixed;
      left: 82px;
    }
  }
  
  @media screen and (max-width: 325px) {
    ._iconsHeader_y23g1_67 {
      position: fixed;
      left: 60px;
    }
  }
  
  @media screen and (max-width: 300px) {
    ._iconsHeader_y23g1_67 {
      position: fixed;
      left: 30px;
    }
  }
  
  ._lightboxVideo_y23g1_2175 {
    margin-left: auto;
    margin-right: auto;
  }
  
  [class^='number-slide'],
  [class*=' number-slide'] {
    background: grey;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 50px;
    color: #fff;
    font-weight: 500;
    height: 300px;
    max-height: 100vh;
  }
  
  ._navigation-wrapper_y23g1_2211 {
    position: relative;
  }
  
  ._dots_y23g1_2219 {
    display: flex;
    padding: 10px 0;
    justify-content: center;
  }
  
  ._dot_y23g1_2219 {
    border: none;
    width: 10px;
    height: 10px;
    background: #c5c5c5;
    border-radius: 50%;
    margin: 0 5px;
    padding: 5px;
    cursor: pointer;
  }
  
  ._dot_y23g1_2219:focus {
    outline: none;
  }
  
  ._dot_y23g1_2219._active_y23g1_1499 {
    background: #000;
  }
  
  ._arrow_y23g1_2269 {
    position: absolute;
    top: 50%;
    font-size: 24px;
    font-weight: bold;
    transition: all 0.2s;
    transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    color: #fff;
    cursor: pointer;
    padding-top: 10px;
    padding-bottom: 10px;
    font-family: sans-serif;
  }
  
  ._leftArrow_y23g1_2299 {
    left: 8px;
    padding-right: 10px;
    padding-top: 30px;
    padding-bottom: 30px;
  }
  
  ._rightArrow_y23g1_2313 {
    left: auto;
    right: 8px;
    padding-left: 10px;
    padding-top: 30px;
    padding-bottom: 30px;
  }
  
  ._arrow_y23g1_2269:hover {
    color: rgb(230, 230, 230);
  }
  
  ._arrow--disabled_y23g1_2337,
  ._arrow--disabled_y23g1_2337:hover {
    color: rgba(255, 255, 255, 0.5);
  }
  
  ._navDotsMargin_y23g1_2347 {
    margin-top: 12px;
  }
  
  ._inactiveThumbnailBorderImgSlider_y23g1_2355 {
    border: 'solid transparent 2px';
  }
  
  ._ytVideoImgSlider_y23g1_2363 {
    width: 100%;
    height: 100%;
  }
  
  ._ytVideoImgSlider_y23g1_2363 iframe {
    width: 100%;
    height: 100%;
  }
  
  ._outerYTVideoImgSlider_y23g1_2383 {
    height: 100%;
  }
  
  ._lightboxjs_y23g1_1 iframe {
    margin: none;
    padding: none;
    border: none;
  }
  
  ._imgSliderArrow_y23g1_2403 {
    z-index: 100000;
    background-color: transparent;
    border: none;
  }
  
  ._thumbnails_y23g1_171 {
    margin-left: auto;
    margin-right: auto;
  }
  
  ._cursorPointer_y23g1_2425 {
    cursor: pointer;
  }
  
  ._lightboxjsIcon_y23g1_2433 > * { color: inherit; fill: inherit }
  
  ._embla_y23g1_1523 {
    margin-left: auto;
    margin-right: auto;
    --slide-spacing: 1rem;
    --slide-size: 100%;
    --slide-height: 19rem;
  }
  
  ._emblaViewport_y23g1_2453 {
    overflow: hidden;
    width: 100vw;
  }
  
  ._emblaContainer_y23g1_2463 {
    backface-visibility: hidden; 
    touch-action: pan-y;
    height: auto;
    margin-left: calc(var(--slide-spacing) * -1);
    display: grid;  
    grid-auto-flow: column;  
    grid-auto-columns: 100%; 
    max-width: 100vw;
    margin-left: auto;
    margin-right: auto; 
    /* width: 80%;
  */
  }
  
  ._emblaContainerImgMetadata_y23g1_2493 {
    width: 78vw;
    max-width: 78vw;
  }
  
  ._imgdrag_y23g1_2503 ._emblaSlide_y23g1_2503 {
    flex: 0 0 80%;
    min-width: 0;
    max-width: 100%;
    padding-left: 12px;
    position: relative;
    margin-left: auto;
    margin-right: auto;
  }
  
  ._emblaThumbsViewport_y23g1_2523 {
    overflow: hidden;
  }
  
  ._emblaThumbsContainer_y23g1_2531 {
    display: flex;
    flex-direction: row;
    margin-left: calc(var(--thumbs-slide-spacing) * -1);
    width: 100%;
    /* align-items: center;
    text-align: center;
    width: fit-content; */
    /* justify-content: center; */
    
  }
  
  ._emblaThumbsContainer_y23g1_2531::before, ._emblaThumbsContainer_y23g1_2531::after {
    content: '';  /* Insert pseudo-element */
    margin: auto; /* Make it push flex items to the center */
  }
  
  
  ._emblaThumbsSlide_y23g1_2567 {
    /* min-width: 0; */
    padding-left: var(--thumbs-slide-spacing);
    /* position: relative; */
    /* width: 140px; */
  }
  
  ._emblaThumbsSlideImg_y23g1_2581 {
    /* display: block; */
    height: var(--thumbs-slide-height);
    width: 100%;
    object-fit: cover;
  }
  
  ._mlAuto_y23g1_2595 {
    margin-left: auto;
  }
  
  ._metadata_y23g1_2603 {
    color: white;
  }
  
  ._emblaSlideGrid_y23g1_2611 {
    display: flex;
  }
  
  ._metadata_y23g1_2603 {
    text-align: left;
    min-width: 17vw;
    max-width: 17vw;
    padding-top: 5vw;
  }
  
  ._metadataPanel_y23g1_2633 {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }
  
  ._metadataInnerContainer_y23g1_2645 {
    padding-left: 7vw;
  }
  
  ._metadataInnerContainer_y23g1_2645 span {
    display: block;
  }
  
  
  ._imgMetadataCloseBtn_y23g1_2663 {
    position: absolute;
    top: 1%;
    right: 2%;
    background: none;
    color: white;
    border: none;
    cursor: pointer;
  }
  
  /* Styling from react-zoom-pan-pinch library */
  ._reactTransformWrapper_y23g1_2685 {
    position: relative;
    width: -moz-fit-content;
    width: fit-content;
    height: -moz-fit-content;
    height: fit-content;
    overflow: hidden;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -moz-user-select: none; /* Firefox */
    -khtml-user-select: none; /* Konqueror HTML */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none;
    margin: 0;
    padding: 0;
  }
  
  ._reactTransformComponent_y23g1_1797 {
    display: flex;
    flex-wrap: wrap;
    width: -moz-fit-content;
    width: fit-content;
    height: -moz-fit-content;
    height: fit-content;
    margin: 0;
    padding: 0;
    transform-origin: 0% 0%;
  }
  
  ._reactTransformComponent_y23g1_1797 img {
    pointer-events: none;
  }
  
  ._navigationDot_y23g1_195 {
    height: 10px;
    width: 10px;
    background-color: silver;
    border-radius: 8px;
    border: none;
    cursor: pointer;
  }
  
  ._navigationDotContainer_y23g1_2769 {
    padding-top: 24px;
    padding-bottom: 24px;
    padding-left: 12px;
    padding-right: 12px;
  }
  
  ._imgfade_y23g1_2783._emblaContainer_y23g1_2463 {
    transform: none !important; /* override Embla */
    display: flex;
    height: 250px;
  }
  
  ._imgfade_y23g1_2783._emblaSlide_y23g1_2503 {
    flex: 0 0 auto;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0 !important; /* override Embla */
    right: 0 !important; /* override Embla */
    opacity: 0;
    transition: opacity 0.5s;
    counter-increment: embla;
    border-radius: 0.5rem;
  }
  
  ._imgfade_y23g1_2783._emblaSlideSelected_y23g1_2823 {
    opacity: 1;
    transition: opacity 0.3s;
    z-index: 1;
  }
  
  ._imgfade_y23g1_2783._emblaSlide_y23g1_2503:before {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  ._fullImg_y23g1_2849 {
    height: 84vh;
    max-height: 84vh;
    object-fit: contain;
  }`;
(function() {
  if (typeof document === "undefined") {
    return;
  }
  if (!document.getElementById(digest2)) {
    var el = document.createElement("style");
    el.id = digest2;
    el.textContent = css2;
    document.head.appendChild(el);
  }
})();
var SlideshowLightbox_module_css_default = { "lightboxjs": "_lightboxjs_y23g1_1", "slideshowContainer": "_slideshowContainer_y23g1_37", "slideshowBtn": "_slideshowBtn_y23g1_55", "closeIcon": "_closeIcon_y23g1_63", "iconsHeader": "_iconsHeader_y23g1_67", "prev1": "_prev1_y23g1_71", "next1": "_next1_y23g1_73", "icon": "_icon_y23g1_67", "prevIcon": "_prevIcon_y23g1_89", "nextIcon": "_nextIcon_y23g1_91", "show": "_show_y23g1_101", "displayHidden": "_displayHidden_y23g1_109", "thumbnail": "_thumbnail_y23g1_117", "hoverShadow": "_hoverShadow_y23g1_131", "thumbnails": "_thumbnails_y23g1_171", "thumbnailsWithCaption": "_thumbnailsWithCaption_y23g1_187", "navigationDots": "_navigationDots_y23g1_195", "imageSlide": "_imageSlide_y23g1_211", "thumbnailsOuterContainer": "_thumbnailsOuterContainer_y23g1_221", "hideControlsBar": "_hideControlsBar_y23g1_235", "slideshowImg": "_slideshowImg_y23g1_235", "slideshowInnerContainer": "_slideshowInnerContainer_y23g1_245", "videoThumbnailsOuterContainer": "_videoThumbnailsOuterContainer_y23g1_265", "imgTitleContainer": "_imgTitleContainer_y23g1_273", "thumbnailsOuterContainerMetadata": "_thumbnailsOuterContainerMetadata_y23g1_349", "thumbnailsAndCaption": "_thumbnailsAndCaption_y23g1_365", "htmlVideoOuterContainer": "_htmlVideoOuterContainer_y23g1_373", "caption": "_caption_y23g1_385", "galleryImg": "_galleryImg_y23g1_405", "modalContainer": "_modalContainer_y23g1_415", "slideshowAnimContainer": "_slideshowAnimContainer_y23g1_453", "fullScreenContainer": "_fullScreenContainer_y23g1_489", "imageInnerContainer": "_imageInnerContainer_y23g1_501", "magnifyWrapper": "_magnifyWrapper_y23g1_539", "slideshowInnerContainerImgMetadata": "_slideshowInnerContainerImgMetadata_y23g1_579", "slideshowInnerVideoContainer": "_slideshowInnerVideoContainer_y23g1_593", "slideshowInnerContainerThumbnails": "_slideshowInnerContainerThumbnails_y23g1_601", "lightboxContainer": "_lightboxContainer_y23g1_625", "slideshowAnimImg": "_slideshowAnimImg_y23g1_697", "controls": "_controls_y23g1_707", "ytVideo": "_ytVideo_y23g1_747", "videoOuterContainer": "_videoOuterContainer_y23g1_759", "customVideoContainer": "_customVideoContainer_y23g1_787", "customEmbedContainer": "_customEmbedContainer_y23g1_787", "videoIconsHeader": "_videoIconsHeader_y23g1_797", "lightbox": "_lightbox_y23g1_1", "imgTitle": "_imgTitle_y23g1_273", "slideshowImgFullscreen": "_slideshowImgFullscreen_y23g1_1071", "slideshowInnerContainerFullScreen": "_slideshowInnerContainerFullScreen_y23g1_1107", "fullScreenLightboxImg": "_fullScreenLightboxImg_y23g1_1115", "opacityFade": "_opacity-fade_y23g1_1167", "imageSliderThumbnails": "_imageSliderThumbnails_y23g1_1195", "slideshowImgMetadata": "_slideshowImgMetadata_y23g1_1271", "prev1Metadata": "_prev1Metadata_y23g1_1279", "hideControlsBarAndCaption": "_hideControlsBarAndCaption_y23g1_1317", "lightboxImg": "_lightboxImg_y23g1_1335", "lightIcon": "_lightIcon_y23g1_1385", "darkIcon": "_darkIcon_y23g1_1411", "lightHeaderIcon": "_lightHeaderIcon_y23g1_1441", "darkHeaderIcon": "_darkHeaderIcon_y23g1_1467", "magnifierImage": "_magnifierImage_y23g1_1491", "active": "_active_y23g1_1499", "inactiveThumbnailBorder": "_inactiveThumbnailBorder_y23g1_1507", "emblaThumbs": "_emblaThumbs_y23g1_1523", "htmlVideo": "_htmlVideo_y23g1_373", "containImg": "_containImg_y23g1_1767", "reactTransformComponent": "_reactTransformComponent_y23g1_1797", "loader": "_loader_y23g1_1819", "rotation": "_rotation_y23g1_1", "dayLoader": "_dayLoader_y23g1_1865", "nightLoader": "_nightLoader_y23g1_1875", "closeButton": "_closeButton_y23g1_1897", "closeButtonRounded": "_closeButtonRounded_y23g1_1897", "slideImageAndCaption": "_slideImageAndCaption_y23g1_1991", "roundedBorder": "_roundedBorder_y23g1_2023", "maxWidthFull": "_maxWidthFull_y23g1_2031", "maxWidthWithoutMagnifier": "_maxWidthWithoutMagnifier_y23g1_2039", "lightboxVideo": "_lightboxVideo_y23g1_2175", "navigationWrapper": "_navigation-wrapper_y23g1_2211", "dots": "_dots_y23g1_2219", "dot": "_dot_y23g1_2219", "arrow": "_arrow_y23g1_2269", "leftArrow": "_leftArrow_y23g1_2299", "rightArrow": "_rightArrow_y23g1_2313", "arrowDisabled": "_arrow--disabled_y23g1_2337", "navDotsMargin": "_navDotsMargin_y23g1_2347", "inactiveThumbnailBorderImgSlider": "_inactiveThumbnailBorderImgSlider_y23g1_2355", "ytVideoImgSlider": "_ytVideoImgSlider_y23g1_2363", "outerYtVideoImgSlider": "_outerYTVideoImgSlider_y23g1_2383", "imgSliderArrow": "_imgSliderArrow_y23g1_2403", "cursorPointer": "_cursorPointer_y23g1_2425", "lightboxjsIcon": "_lightboxjsIcon_y23g1_2433", "embla": "_embla_y23g1_1523", "emblaViewport": "_emblaViewport_y23g1_2453", "emblaContainer": "_emblaContainer_y23g1_2463", "emblaContainerImgMetadata": "_emblaContainerImgMetadata_y23g1_2493", "imgdrag": "_imgdrag_y23g1_2503", "emblaSlide": "_emblaSlide_y23g1_2503", "emblaThumbsViewport": "_emblaThumbsViewport_y23g1_2523", "emblaThumbsContainer": "_emblaThumbsContainer_y23g1_2531", "emblaThumbsSlide": "_emblaThumbsSlide_y23g1_2567", "emblaThumbsSlideImg": "_emblaThumbsSlideImg_y23g1_2581", "mlAuto": "_mlAuto_y23g1_2595", "metadata": "_metadata_y23g1_2603", "emblaSlideGrid": "_emblaSlideGrid_y23g1_2611", "metadataPanel": "_metadataPanel_y23g1_2633", "metadataInnerContainer": "_metadataInnerContainer_y23g1_2645", "imgMetadataCloseBtn": "_imgMetadataCloseBtn_y23g1_2663", "reactTransformWrapper": "_reactTransformWrapper_y23g1_2685", "navigationDot": "_navigationDot_y23g1_195", "navigationDotContainer": "_navigationDotContainer_y23g1_2769", "imgfade": "_imgfade_y23g1_2783", "emblaSlideSelected": "_emblaSlideSelected_y23g1_2823", "fullImg": "_fullImg_y23g1_2849" };

// lib/utility.js
import { useState as useState2, useCallback, useEffect, useRef } from "react";
var wrapNums = (minNum, maxNum, v) => {
  if (minNum == maxNum) {
    return minNum;
  }
  let rangeSize = maxNum - minNum;
  return ((v - minNum) % rangeSize + rangeSize) % rangeSize + minNum;
};
var shouldAutoplay = (elem) => {
  if (elem.type == "yt" && elem.autoPlay != true && elem.autoPlay != "true") {
    return false;
  } else if (elem.autoPlay == false || elem.autoPlay == "false") {
    return false;
  }
  return true;
};
var getVideoHeight = (elem) => {
  if (elem.videoHeight) {
    return elem.videoHeight;
  }
  return "200";
};
var getVideoWidth = (elem) => {
  if (elem.videoWidth) {
    return elem.videoWidth;
  }
  return "900";
};
var getScale = (num, maxScale) => {
  if (num < 1) {
    return 1;
  } else if (num > maxScale) {
    return maxScale;
  }
  return num;
};

// lib/SlideshowLightbox.tsx
import {
  ZoomIn,
  ZoomOut,
  Fullscreen,
  PlayCircleFill,
  Search,
  Download,
  PauseCircleFill,
  FullscreenExit,
  InfoCircle,
  XLg,
  GridFill
} from "react-bootstrap-icons";
import { Portal } from "react-portal";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { saveAs } from "file-saver";
import Div100vh from "react-div-100vh";
import KeyHandler from "@banzai-inc/react-key-handler";
import { useInterval } from "usehooks-ts";
import useEmblaCarousel from "embla-carousel-react";
import YouTube from "react-youtube";
import useResizeObserver from "@react-hook/resize-observer";
import exifr from "exifr";
import { jsx, jsxs as jsxs2 } from "react/jsx-runtime";
import { createElement } from "react";
var thumbnailVariants = {
  visible: { opacity: 1, y: 0 },
  hidden: { opacity: 0, y: 100 }
};
var themes = {
  day: {
    background: "white",
    iconColor: "black",
    thumbnailBorder: "solid transparent 2px",
    textColor: "black",
    metadataTextColor: "black"
  },
  night: {
    background: "#151515",
    iconColor: "#626b77",
    thumbnailBorder: "solid rgb(107, 133, 206)  2px",
    textColor: "silver",
    metadataTextColor: "white"
  },
  lightbox: {
    background: "rgba(12, 12, 12, 0.93)",
    iconColor: "#626b77",
    thumbnailBorder: "solid rgb(107, 133, 206) 2px",
    textColor: "silver",
    metadataTextColor: "white"
  }
};
var inactiveThumbnailBorder = "solid transparent 2px";
var defaultTheme = "night";
var mobileWidth = 768;
var tabletWidth = 1100;
var usePrevious = (value) => {
  const ref = useRef2();
  useEffect2(() => {
    ref.current = value;
  });
  return ref.current;
};
var SlideshowLightbox = React.forwardRef(
  (props, ref) => {
    useImperativeHandle(
      ref,
      () => ({
        reset() {
          initImages(true, true);
        }
      })
    );
    const [[imgSlideIndex, direction], setImgSlideIndex] = useState3([0, 0]);
    const [showModal, setShowModal] = useState3(false);
    const [slideAnimDuration, setSlideAnimDuration] = useState3(props.slideDuration ? props.slideDuration : 25);
    const [isSlideshowPlaying, setIsSlideshowPlaying] = useState3(false);
    const [emblaReinitialized, setEmblaReinitialized] = useState3(false);
    const [images, setImages] = useState3([]);
    const [previewImageElems, setPreviewImageElems] = useState3([]);
    const slideIndex = wrapNums(0, images.length, imgSlideIndex);
    const [reactSwipeOptions, setReactSwipeOptions] = useState3({
      loop: true,
      startIndex: 0,
      active: true,
      duration: slideAnimDuration,
      dragThreshold: 10,
      skipSnaps: true
    });
    let initialThumbnailOptions = {
      startIndex: 0,
      containScroll: "keepSnaps",
      dragFree: true
    };
    const [width, setWidth] = useState3(0);
    const isMobile = width <= mobileWidth;
    const isTablet = width <= tabletWidth;
    const [thumbnailSwipeOptions, setThumbnailSwipeOptions] = useState3(initialThumbnailOptions);
    const [carouselReady, setCarouselReady] = useState3(false);
    const [isTabletUserAgent, setIsTabletUserAgent] = useState3(false);
    const [zoomedIn, setZoomedIn] = useState3(false);
    const [isDisplay, setIsDisplay] = useState3(false);
    const [fullImg, setFullImg] = useState3(false);
    const [isOpen, setIsOpen] = useState3(false);
    const [prevFocusedElem, setPrevFocusedElem] = useState3(null);
    const [animationEntered, setAnimationEntered] = useState3(false);
    const [lightboxModalWidth, setLightboxModalWidth] = useState3(
      props.lightboxWidth ? props.lightboxWidth : "100vw"
    );
    const [rightSidebarComponent, setRightSidebarComponent] = useState3(
      props.rightSidebarComponent ? props.rightSidebarComponent : null
    );
    const [magnifyingGlassFeature, _setMagnifyingGlassFeature] = useState3(
      props.magnifyingGlass ? props.magnifyingGlass : false
    );
    const [disableZoom, setDisableZoom] = useState3(
      props.disableImageZoom ? props.disableImageZoom : false
    );
    const [slideshowInterval, setSlideshowInterval] = useState3(
      props.slideshowInterval ? props.slideshowInterval : 1700
    );
    const [rightArrowStyle, setRightArrowStyle] = useState3(
      props.rightArrowStyle ? props.rightArrowStyle : {}
    );
    const [leftArrowStyle, setLeftArrowStyle] = useState3(
      props.leftArrowStyle ? props.leftArrowStyle : {}
    );
    const [maxScale, setMaxScale] = useState3(
      props.maxZoomScale ? getScale(props.maxZoomScale, 24) : 8
    );
    const [isRounded, setIsRounded] = useState3(
      props.roundedImages ? props.roundedImages : false
    );
    const [showControls, setShowControls] = useState3(
      props.showControls ? props.showControls : true
    );
    const [displayFullScreenIcon, setDisplayFullScreenIcon] = useState3(
      props.showFullScreenIcon ? props.showFullScreenIcon : true
    );
    const [displayThumbnailIcon, setDisplayThumbnailIcon] = useState3(
      props.showThumbnailIcon ? props.showThumbnailIcon : true
    );
    const [displaySlideshowIcon, setDisplaySlideshowIcon] = useState3(
      props.showSlideshowIcon ? props.showSlideshowIcon : true
    );
    const [displayMagnificationIcons, setDisplayMagnificationIcons] = useState3(
      props.showMagnificationIcons ? props.showMagnificationIcons : true
    );
    const [nextArrowElem, setNextArrowElem] = useState3(
      props.nextArrow ? props.nextArrow : null
    );
    const [isImageComponent, setImageComponent] = useState3(
      props.imageComponent ? props.imageComponent : null
    );
    const [prevArrowElem, setPrevArrowElem] = useState3(
      props.prevArrow ? props.prevArrow : null
    );
    const [modalCloseOption, setModalCloseOption] = useState3(
      props.modalClose ? props.modalClose : "default"
    );
    const [showDownloadBtn, setShowDownloadBtn] = useState3(
      props.downloadImages ? props.downloadImages : false
    );
    const [navigationDots, setNavigationDots] = useState3(
      props.showNavigationDots ? props.showNavigationDots : false
    );
    const [metadataLocale, setMetadataLocale] = useState3(props.metadataTimeLocale ? props.metadataTimeLocale : "en-US");
    const [isRTL, setIsRTL] = useState3(props.rtl ? props.rtl : false);
    const [frameworkID, setFrameworkID] = useState3(
      props.framework ? props.framework : ""
    );
    const [lightboxIdentifier, setLightboxIdentifier] = useState3(
      props.lightboxIdentifier ? props.lightboxIdentifier : false
    );
    const [imageFullScreen, setImageFullScreen] = useState3(
      props.fullScreen ? props.fullScreen : false
    );
    const [licenseKey, setLicenseKey] = useState3(
      props.licenseKey ? props.licenseKey : ""
    );
    const [displayLoader, setDisplayLoader] = useState3(
      props.showLoader ? props.showLoader : false
    );
    const [customControlComponent, setCustomControlComponent] = useState3(
      props.controlComponent ? props.controlComponent : false
    );
    const [startingIndex, setStartingIndex] = useState3(
      props.startingSlideIndex ? props.startingSlideIndex : 0
    );
    const [backgroundColor, setBackgroundColor] = useState3(
      props.backgroundColor ? props.backgroundColor : themes[defaultTheme].background
    );
    const [iconColor, setIconColor] = useState3(
      props.iconColor ? props.iconColor : null
    );
    const [textColor, setTextColor] = useState3(
      props.textColor ? props.textColor : themes[defaultTheme].textColor
    );
    const [showControlsBar, setShowControlsBar] = useState3(
      props.showControlsBar ? props.showControlsBar : true
    );
    const [coverMode, setCoverMode] = useState3(
      props.useCoverMode ? props.useCoverMode : false
    );
    const [displayImgMetadata, setDisplayImgMetadata] = useState3(
      props.displayMetadata ? props.displayMetadata : false
    );
    const [showImgMetadataPanel, setShowImgMetadataPanel] = useState3(false);
    const [imgMetadata, setImgMetadata] = useState3({});
    const [showThumbnails, setShowThumbnails] = useState3(
      props.showThumbnails ? props.showThumbnails : false
    );
    const [animatedThumbnails, setAnimatedThumbnails] = useState3(
      props.animateThumbnails ? props.animateThumbnails : true
    );
    const [imgAnimation, setImgAnimation] = useState3(
      props.imgAnimation ? props.imgAnimation : "imgDrag"
    );
    const [arrowStyle, setArrowStyle] = useState3(
      props.arrowStyle ? props.arrowStyle : "dark"
    );
    const [YTVideoCurrentlyPlaying, setYTVideoCurrentlyPlaying] = useState3(false);
    const [isBrowserFullScreen, setIsBrowserFullScreen] = useState3(false);
    const [enableMagnifyingGlass, setMagnifyingGlass] = useState3(false);
    const [imagesLoaded, setImagesLoaded] = useState3(false);
    const imageRef = useRef2(null);
    const [zoomIdx, setZoomIdx] = useState3(0);
    const [imgContainHeight, setImgContainHeight] = useState3(500);
    const [imgContainWidth, setImgContainWidth] = useState3(426);
    const [isInit, setIsInit] = useState3(false);
    const { open } = props;
    const previousValues = usePrevious({ open });
    const zoomReferences = useRef2([]);
    const videoReferences = useRef2({});
    const btnRef = useRef2(null);
    const [videoElements, setVideoElements] = useState3({});
    const [isLoading, setIsLoading] = useState3(true);
    const [noWindow, setNoWindow] = useState3(props.noWindow ? props.noWindow : false);
    const [touchStart, setTouchStart] = useState3(0);
    const [touchEnd, setTouchEnd] = useState3(0);
    const [mouseStartX, setMouseStartX] = useState3(0);
    const [mouseStartY, setMouseStartY] = useState3(0);
    const minimumSwipeDistance = 50;
    const onTouchStart = (e) => {
      setTouchEnd(null);
      setTouchStart(e.targetTouches[0].clientX);
    };
    const onTouchMove = (e) => setTouchEnd(e.targetTouches[0].clientX);
    const onTouchEnd = () => {
      if (touchStart != null && touchEnd != null && imgAnimation == "fade") {
        const distance = touchStart - touchEnd;
        if (distance != null) {
          const isLeftSwipe = distance > minimumSwipeDistance;
          const isRightSwipe = distance < -minimumSwipeDistance;
          if (isLeftSwipe) {
            nextSlide();
          } else if (isRightSwipe) {
            prevSlide();
          }
        }
      }
    };
    const delta = 6;
    const onMouseDown = (event) => {
      setMouseStartX(event.pageX);
      setMouseStartY(event.pageY);
    };
    const onMouseUp = (event) => {
      if (imgAnimation == "fade" && zoomedIn == false) {
        const differenceX = Math.abs(event.pageX - mouseStartX);
        if (differenceX > delta) {
          const isLeftDragMotion = mouseStartX - event.pageX > delta;
          const isRightDragMotion = mouseStartX - event.pageX < -delta;
          if (isLeftDragMotion) {
            nextSlide();
          } else if (isRightDragMotion) {
            prevSlide();
          }
        }
      }
    };
    const createCustomThumbnailBorder = () => {
      if (props.thumbnailBorder) {
        return `solid ${props.thumbnailBorder} 2px`;
      }
    };
    const [thumbnailBorder, setThumbnailBorder] = useState3(
      props.thumbnailBorder ? createCustomThumbnailBorder() : themes[defaultTheme].thumbnailBorder
    );
    const [emblaRef, emblaApi] = useEmblaCarousel(reactSwipeOptions);
    const [emblaThumbsRef, emblaThumbsApi] = useEmblaCarousel(thumbnailSwipeOptions);
    const getLoaderThemeClass = () => {
      if (props.theme) {
        if (props.theme == "night" || props.theme == "lightbox") {
          return SlideshowLightbox_module_css_default.nightLoader;
        } else if (props.theme == "day") {
          return SlideshowLightbox_module_css_default.dayLoader;
        }
      }
      return SlideshowLightbox_module_css_default.nightLoader;
    };
    const scrollPrev = useCallback2(() => {
      if (emblaApi) {
        emblaApi.scrollPrev();
      }
    }, [emblaApi]);
    const scrollNext = useCallback2(() => {
      if (emblaApi) {
        emblaApi.scrollNext();
      }
    }, [emblaApi]);
    const variants = {
      active: {
        opacity: 1
      },
      inactive: {
        opacity: 0
      }
    };
    const isImageCaption = () => {
      if (props.images && props.images.length > 0) {
        if (props.images[slideIndex]?.caption) {
          return true;
        }
      }
      return false;
    };
    const displayDownloadBtn = () => {
      if (isVideo(slideIndex)) {
        return false;
      } else {
        return showDownloadBtn;
      }
    };
    function handleWindowResize() {
      if (!noWindow) {
        setWidth(window.innerWidth);
      }
    }
    const shouldDisplayMagnifyingGlassIcon = () => {
      if (isVideo(slideIndex)) {
        return false;
      }
      if (isMobile == true) {
        return false;
      }
      if (imageFullScreen == true) {
        return false;
      }
      if (magnifyingGlassFeature == true) {
        return true;
      }
      return false;
    };
    const getImageStyle = () => {
      let styleObject = {};
      if (isImageCaption() && showThumbnails == false) {
        styleObject["height"] = "77vh";
      }
      if (isImageCaption() && showThumbnails) {
        styleObject["height"] = "67vh";
      }
      if (isRounded) {
        styleObject["borderRadius"] = "20px";
      }
      if (modalCloseOption == "clickOutside") {
        styleObject["pointerEvents"] = "auto";
      }
      if (isImageComponent && showThumbnails == false && !isMobile) {
        styleObject["height"] = "85vh";
      }
      return styleObject;
    };
    const shouldDisplaySlideshowIcon = () => {
      if (props.showSlideshowIcon != void 0) {
        return props.showSlideshowIcon;
      }
      if (images) {
        if (images.length == 1) {
          return false;
        }
      } else if (props.images) {
        if (props.images.length == 1) {
          return false;
        }
      }
      return true;
    };
    const navigationClick = (index) => {
      initLoader(index);
      setCurrentSlide(index);
    };
    const checkModalClick = (e) => {
      const modals = document.getElementsByClassName("imageModal");
      let arr_modals = Array.from(modals);
      for (let i = 0; i < arr_modals.length; i++) {
        let elem = arr_modals[i];
        let clickInside = elem.contains(e.target);
        if (clickInside) {
          return;
        }
      }
      closeModal();
    };
    const isZoomEnabled = () => {
      if (disableZoom == true) {
        return false;
      }
    };
    const getRTLIndex = (img_gallery_length, i) => {
      let index;
      if (i == 0) {
        index = img_gallery_length - 1;
      } else if (i == img_gallery_length - 1) {
        index = 0;
      } else {
        index = img_gallery_length - i - 1;
      }
      return index;
    };
    const getMetadataTextColor = () => {
      if (props.theme) {
        if (themes[props.theme]) {
          return themes[props.theme].metadataTextColor;
        }
      } else {
        return themes[defaultTheme].metadataTextColor;
      }
    };
    const fullScreen = () => {
      let lightbox = document.getElementById("slideshowAnim");
      openFullScreen(lightbox);
      setIsBrowserFullScreen(true);
      initFullScreenChangeEventListeners();
    };
    const exitFullScreenHandler = () => {
      if (document["webkitIsFullScreen"] || document["mozFullScreen"] || document["msFullscreenElement"]) {
        setIsBrowserFullScreen(true);
      } else {
        if (isBrowserFullScreen) {
          closeFullScreen(document);
        }
        removeFullScreenChangeEventListeners();
        setIsBrowserFullScreen(false);
      }
    };
    const exitFullScreen = () => {
      closeFullScreen(document);
      removeFullScreenChangeEventListeners();
      setIsBrowserFullScreen(false);
    };
    const emblaSlideSelect = useCallback2((emblaApi2) => {
    }, []);
    useEffect2(
      () => {
        if (emblaApi)
          emblaApi.on("slidesInView", emblaSlideSelect);
      },
      [emblaApi, emblaSlideSelect]
    );
    const updateImageSlideshow = (newDirection) => {
      if (isRTL) {
        scrollPrev();
      } else {
        scrollNext();
      }
      setImgSlideIndex([imgSlideIndex + newDirection, newDirection]);
      if (isRTL) {
        setZoomIdx(zoomIdx - 1 < 0 ? images.length - 1 : zoomIdx - 1);
      } else {
        setZoomIdx(zoomIdx + 1 >= images.length ? 0 : zoomIdx + 1);
      }
    };
    const displayArrows = () => {
      if (props.showArrows == false) {
        return false;
      }
      if (props.images) {
        if (props.images.length == 1) {
          return false;
        }
      } else if (images.length == 1) {
        return false;
      }
      return true;
    };
    const initLoader = (newIndex) => {
      if (props.showLoader && props.images) {
        if (!isVideo(newIndex) && images[newIndex].loaded != true) {
          setDisplayLoader(true);
        } else if (props.showLoader && props.images && images[newIndex]["loaded"]) {
          setDisplayLoader(false);
        }
      }
    };
    const getImageCaption = () => {
      if (props.images && props.images.length > 0) {
        return props.images[slideIndex].caption;
      }
      return "";
    };
    const getArrowStyle = () => {
      if (arrowStyle == "dark") {
        return SlideshowLightbox_module_css_default.darkIcon;
      } else if (arrowStyle == "light") {
        return SlideshowLightbox_module_css_default.lightIcon;
      }
    };
    const getIconStyle = () => {
      if (arrowStyle == "dark") {
        return SlideshowLightbox_module_css_default.darkHeaderIcon;
      } else if (arrowStyle == "light") {
        return SlideshowLightbox_module_css_default.lightHeaderIcon;
      }
    };
    const setCurrentSlide = (newIndex) => {
      let newDirection;
      if (newIndex > imgSlideIndex) {
        newDirection = 1;
      } else {
        newDirection = -1;
      }
      setZoomIdx(newIndex);
      setImgSlideIndex([newIndex, newDirection]);
      if (emblaApi) {
        emblaApi.scrollTo(newIndex);
      }
    };
    const dispatchOpenEvent = () => {
      if (props.onOpen) {
        props.onOpen(slideIndex, images[slideIndex]);
      }
      if (props.onSelect) {
        props.onSelect(slideIndex, images[slideIndex]);
      }
    };
    const dispatchCloseEvent = () => {
      if (props.onClose) {
        props.onClose(slideIndex);
      }
    };
    const dispatchNextImgEvent = (newIndex) => {
      if (props.onNext) {
        props.onNext(newIndex, images[newIndex]);
      }
    };
    const dispatchPrevImgEvent = (newIndex) => {
      if (props.onPrev) {
        props.onPrev(newIndex, images[newIndex]);
      }
    };
    const closeModal = () => {
      setZoomIdx(0);
      if (isBrowserFullScreen) {
        exitFullScreen();
      }
      if (isSlideshowPlaying) {
        setIsSlideshowPlaying(false);
      }
      setShowModal(false);
      setIsOpen(false);
      setCarouselReady(false);
      setEmblaReinitialized(false);
      if (prevFocusedElem)
        prevFocusedElem?.focus();
    };
    const openModal = (num) => {
      if (emblaApi) {
        emblaApi.reInit();
        if (emblaThumbsApi) {
          emblaThumbsApi?.scrollTo(emblaApi.selectedScrollSnap());
        }
      }
      setImgSlideIndex([num, 1]);
      setShowModal(true);
      setIsOpen(true);
    };
    const setItemLoaded = (index) => {
      if (props.images) {
        setImages(
          (images2) => images2.map((img, i) => index === i ? {
            ...img,
            loaded: true
          } : img)
        );
      }
    };
    const setImagesItemLoaded = (index) => {
      setImages(
        (images2) => images2.map((img, i) => index === i ? {
          ...img,
          loaded: true
        } : img)
      );
    };
    const resetMedia = (slide_index) => {
      resetVideo(slide_index);
      resetImage();
    };
    const initImgMetadataPanel = () => {
      if (isMobile && showImgMetadataPanel) {
        setShowImgMetadataPanel(false);
      }
    };
    const initSlide = (newSlideIndex) => {
      setImgSlideIndex([newSlideIndex, 1]);
      let wrap_slide_index = wrapNums(0, images.length, newSlideIndex);
      setZoomIdx(wrap_slide_index);
      initLoader(wrap_slide_index);
      if (displayImgMetadata) {
        initImgMetadataPanel();
        if (!imgMetadata[wrap_slide_index]) {
          setIsLoading(true);
        }
      }
    };
    const nextSlide = () => {
      scrollNext();
      initSlide(imgSlideIndex + 1);
      if (imgAnimation == "fade") {
        dispatchNextImgEvent((imgSlideIndex + 1) % images.length);
      }
    };
    const prevSlide = () => {
      scrollPrev();
      initSlide(imgSlideIndex - 1);
      if (imgAnimation == "fade") {
        dispatchPrevImgEvent((imgSlideIndex - 1) % images.length);
      }
    };
    const setThumbnailStartIndex = (index) => {
      let thumbnailSwipeOptionConfig = thumbnailSwipeOptions;
      thumbnailSwipeOptionConfig.startIndex = index;
      setThumbnailSwipeOptions(thumbnailSwipeOptionConfig);
    };
    const openModalWithSlideNum = (index) => {
      let reactSwipeOptionConfig = reactSwipeOptions;
      reactSwipeOptionConfig.startIndex = index;
      setReactSwipeOptions(reactSwipeOptionConfig);
      setThumbnailStartIndex(index);
      setZoomIdx(index);
      openModal(index);
    };
    const saveImage = () => {
      if (props.images.length > 0) {
        if (props.images[slideIndex].original) {
          saveAs(props.images[slideIndex].original, "image.jpg");
        } else {
          saveAs(props.images[slideIndex]["src"], "image.jpg");
        }
      } else {
        if (images[slideIndex].src) {
          saveAs(images[slideIndex].src, "image.jpeg");
        }
      }
    };
    const playSlideshow = () => {
      setMagnifyingGlass(false);
      if (isRTL) {
        updateImageSlideshow(-1);
      } else {
        updateImageSlideshow(1);
      }
      setIsSlideshowPlaying(true);
    };
    const stopSlideshow = () => {
      setIsSlideshowPlaying(false);
    };
    const getEmbedIndex = (slide_index, elems) => {
      if (props.images) {
        let iframe_index = 0;
        for (let i = 0; i < props.images.length; i++) {
          let item = props.images[i];
          if (item.type == "customVideoEmbed" || item.type == "yt") {
            if (i == slide_index) {
              iframe_index++;
              break;
            } else {
              iframe_index++;
            }
          }
        }
        return iframe_index - 1;
      }
    };
    const getEmblaClass = (index) => {
      if (displayImgMetadata) {
        return SlideshowLightbox_module_css_default.emblaSlideGrid;
      }
      if (slideIndex == index && imgAnimation == "fade") {
        return `${SlideshowLightbox_module_css_default.imgfade} ${SlideshowLightbox_module_css_default.emblaSlide} ${SlideshowLightbox_module_css_default.emblaSlideSelected}`;
      } else if (imgAnimation == "fade") {
        return `${SlideshowLightbox_module_css_default.imgfade} ${SlideshowLightbox_module_css_default.emblaSlide}`;
      } else {
        return SlideshowLightbox_module_css_default.emblaSlide;
      }
    };
    const resetVideo = (slide_index) => {
      if (props.images) {
        let elem = props.images[slide_index];
        if (elem) {
          if (elem.type == "htmlVideo") {
            videoReferences.current[slide_index].pause();
          } else if (elem.type == "yt") {
            if (videoElements[slide_index]) {
              videoElements[slide_index].target.pauseVideo();
            }
          } else if (elem.type == "customVideoEmbed") {
            let lightboxjs_elem = document.getElementById("lightboxContainer");
            let elems = lightboxjs_elem?.querySelectorAll("iframe");
            if (elems) {
              let iframe_elem_index = getEmbedIndex(slide_index, elems);
              if (iframe_elem_index != void 0 && iframe_elem_index >= 0) {
                let iframe = elems[iframe_elem_index];
                let iframe_src = iframe.src;
                iframe.src = iframe_src;
              }
            }
          }
        }
      }
    };
    const getNavigationDot = (index) => {
      return /* @__PURE__ */ jsx(
        "button",
        {
          style: slideIndex === index ? { backgroundColor: "cornflowerblue" } : {},
          className: `${SlideshowLightbox_module_css_default.navigationDot} imageModal`,
          onClick: () => {
            navigationClick(index);
          }
        }
      );
    };
    const getThumbnailsOuterContainerStyle = () => {
      let style = {};
      if (isImageCaption()) {
        if (showThumbnails) {
          style["height"] = "21vh";
        } else {
          style["height"] = "12vh";
        }
        style["backgroundColor"] = backgroundColor;
      }
      return style;
    };
    const getImageThumbnail = (img, index, isNextJS, props2) => {
      return /* @__PURE__ */ jsx("div", { className: `${SlideshowLightbox_module_css_default.emblaThumbsSlide}`, children: /* @__PURE__ */ jsx(
        "img",
        {
          className: `${SlideshowLightbox_module_css_default.thumbnail} imageModal ${props2.thumbnailImgClass ? props2.thumbnailImgClass : ""}  `,
          src: isNextJS == true ? getThumbnailImgSrcNext(img, index) : getThumbnailImgSrc(img, index),
          alt: img.alt,
          onLoad: () => setImagesLoaded(true),
          style: slideIndex === index ? { border: thumbnailBorder } : { border: inactiveThumbnailBorder },
          onClick: (event) => {
            if (props2.onThumbnailClick) {
              props2.onThumbnailClick(index, img);
            }
            navigationClick(index);
          }
        },
        "thumbnail_" + index
      ) }, "thumbnail_slide_" + index);
    };
    const handleError = (event, index) => {
      if (props.onImgError) {
        props.onImgError(event, images[slideIndex], index);
      }
    };
    const resetImage = () => {
      if (enableMagnifyingGlass) {
        initMagnifyingGlass();
      } else {
        if (zoomReferences.current[zoomIdx] != null) {
          zoomReferences.current[zoomIdx].resetTransform();
        }
      }
    };
    const getThumbnailImgSrc = (img, index) => {
      if (props.images && props.images.length > 0) {
        if (props.images[index].thumbnailSrc) {
          return props.images[index].thumbnailSrc;
        }
      }
      if (isVideo(index) && img.thumbnail) {
        return img.thumbnail;
      } else {
        return img.src;
      }
    };
    const getThumbnailImgSrcNext = (img, index) => {
      if (img.thumbnailSrc) {
        return img.thumbnailSrc;
      } else if (isVideo(index)) {
        return img.thumbnail;
      } else {
        let img_src = img.src;
        if (typeof img_src === "object" && !Array.isArray(img_src) && img_src !== null) {
          return img_src.src;
        } else {
          return img_src;
        }
      }
    };
    const isAnimImageComponent = () => {
      if (images) {
        if (images.length == 1) {
          return true;
        }
      }
      return false;
    };
    const initWrapperClassname = () => {
      let classNameStr = "";
      if (props.className) {
        classNameStr += `${props.className} `;
      }
      if (isAnimImageComponent()) {
        if (props.imgWrapperClassName) {
          classNameStr += `${props.imgWrapperClassName} `;
        }
      }
      classNameStr += `${SlideshowLightbox_module_css_default.lightboxjs}`;
      return classNameStr;
    };
    const initStyling = () => {
      if (props.theme) {
        if (themes[props.theme]) {
          setBackgroundColor(themes[props.theme].background);
          setTextColor(themes[props.theme].textColor);
        }
      }
      if (props.fullScreen) {
        if (props.fullScreen == true) {
          setImgAnimation(props.imgAnimation && props.imgAnimation == "imgDrag" ? props.imgAnimation : "fade");
          setIsRounded(false);
        }
      }
    };
    const getMetadataPanel = () => {
      let imgMetadataItem = imgMetadata[slideIndex];
      if (imgMetadataItem) {
        let element = /* @__PURE__ */ jsxs2("div", { className: SlideshowLightbox_module_css_default.metadataPanel, children: [
          /* @__PURE__ */ jsx("b", { children: "Filename" }),
          imgMetadataItem.name ? /* @__PURE__ */ jsx("p", { children: imgMetadataItem.name }) : null,
          imgMetadataItem.createDate ? /* @__PURE__ */ jsxs2("div", { children: [
            /* @__PURE__ */ jsx("b", { children: "Captured Time" }),
            /* @__PURE__ */ jsx("p", { children: imgMetadataItem.createDate.toString() })
          ] }) : null,
          imgMetadataItem.width && imgMetadataItem.height ? /* @__PURE__ */ jsxs2("div", { children: [
            /* @__PURE__ */ jsx("b", { children: "Resolution" }),
            /* @__PURE__ */ jsxs2("p", { children: [
              imgMetadataItem.width,
              "*",
              imgMetadataItem.height
            ] })
          ] }) : null,
          imgMetadataItem.isoData || imgMetadataItem.fNumber || imgMetadataItem.shutterSpeed ? /* @__PURE__ */ jsxs2("div", { children: [
            /* @__PURE__ */ jsx("b", { children: "Image Details" }),
            imgMetadataItem.isoData ? /* @__PURE__ */ jsxs2("span", { children: [
              "ISO ",
              imgMetadataItem.isoData
            ] }) : null,
            imgMetadataItem.fNumber ? /* @__PURE__ */ jsxs2("span", { children: [
              "f",
              imgMetadataItem.fNumber
            ] }) : null,
            imgMetadataItem.shutterSpeed ? /* @__PURE__ */ jsxs2("span", { children: [
              "Shutter speed: ",
              imgMetadataItem.shutterSpeed
            ] }) : null
          ] }) : null
        ] });
        return element;
      }
    };
    const imageSlideElement = (index) => {
      let imageElem;
      if (!props.images) {
        imageElem = /* @__PURE__ */ jsx(
          "img",
          {
            className: `imageModal ${fullImg && props.thumbnailImgAnim ? SlideshowLightbox_module_css_default.fullImg : false}  
          ${props.imgElemClassname ? props.imgElemClassname : ""}
        ${SlideshowLightbox_module_css_default.lightboxImg} 
        ${enableMagnifyingGlass ? SlideshowLightbox_module_css_default.maxWidthFull : SlideshowLightbox_module_css_default.maxWidthWithoutMagnifier}  ${SlideshowLightbox_module_css_default.containImg} `,
            style: getImageStyle(),
            ref: imageRef,
            loading: "lazy",
            src: images[index].original ? images[index].original : images[index].src,
            onError: (event) => {
              handleError(event, index);
            },
            onLoad: (img) => {
              if (index == slideIndex) {
                setDisplayLoader(false);
              }
              if (props.images) {
                setItemLoaded(index);
              } else {
                setImagesItemLoaded(index);
              }
            },
            id: "img"
          }
        );
      } else if (props.images && props.render) {
        imageElem = props.render.imgSlide(props.images[index]);
      } else {
        let img_link;
        if (props.images) {
          if (typeof images[index].src === "object" && !Array.isArray(images[index].src) && images[index].src !== null) {
            img_link = images[index].src?.src;
          } else if (props.coverImageInLightbox == true) {
            img_link = images[index].src;
          } else {
            img_link = images[index].src;
          }
        }
        imageElem = /* @__PURE__ */ jsx(
          "img",
          {
            className: `imageModal  ${fullImg && props.thumbnailImgAnim ? SlideshowLightbox_module_css_default.fullImg : false}   
           ${props.imgElemClassname ? props.imgElemClassname : ""}
        ${SlideshowLightbox_module_css_default.lightboxImg} 
        ${enableMagnifyingGlass ? SlideshowLightbox_module_css_default.maxWidthFull : SlideshowLightbox_module_css_default.maxWidthWithoutMagnifier} ${SlideshowLightbox_module_css_default.containImg} `,
            ref: imageRef,
            loading: "lazy",
            style: getImageStyle(),
            src: images[index].original ? images[index].original : img_link,
            onError: (event) => {
              handleError(event, index);
            },
            onLoad: (img) => {
              if (index == slideIndex) {
                setDisplayLoader(false);
              }
              if (props.images) {
                setItemLoaded(index);
              } else {
                setImagesItemLoaded(index);
              }
            },
            id: "img"
          }
        );
      }
      return imageElem;
    };
    const getCloseIconBtnStyle = () => {
      let style_object = {};
      if (iconColor) {
        style_object = { color: iconColor };
      }
      if (props.closeIconBtnStyle) {
        let closeIconBtnStyleKeys = Object.keys(props.closeIconBtnStyle);
        for (let i = 0; i < closeIconBtnStyleKeys.length; i++) {
          let keyName = closeIconBtnStyleKeys[i];
          let style_obj = props.closeIconBtnStyle[keyName];
          style_object[keyName] = style_obj;
        }
      }
      return style_object;
    };
    const isPanningDisabled = () => {
      if ((isMobile || isTablet || isTabletUserAgent) && zoomedIn == false) {
        return true;
      }
      if ((isMobile || isTablet || isTabletUserAgent) && zoomedIn) {
        return false;
      }
      return false;
    };
    const getImageFilename = (img_src) => {
      let img_src_split = img_src.split("/");
      let name = img_src_split[img_src_split.length - 1];
      return name;
    };
    const parseCreateDate = (js_date) => {
      if (js_date) {
        let date = js_date.getDate();
        let month = js_date.getMonth() + 1;
        let year = js_date.getFullYear();
        let time = js_date.toLocaleTimeString(metadataLocale);
        return "" + year + "-" + (month <= 9 ? "0" + month : month) + "-" + (date <= 9 ? "0" + date : date) + ` ${time}`;
      }
      return "";
    };
    const getLightboxElem = (index) => {
      if (isCustomEmbed(index)) {
        return customEmbedElement(index);
      } else if (isVideo(index)) {
        return videoSlideElement(index);
      } else if (isPictureElement(index)) {
        let elem_metadata = props.images[index]["picture"];
        return /* @__PURE__ */ jsxs2("picture", { className: `imageModal 
      ${SlideshowLightbox_module_css_default.lightboxImg} 
      ${enableMagnifyingGlass ? SlideshowLightbox_module_css_default.maxWidthFull : SlideshowLightbox_module_css_default.maxWidthWithoutMagnifier} `, children: [
          Object.keys(elem_metadata).map((format) => /* @__PURE__ */ jsx(
            "source",
            {
              type: format,
              srcSet: elem_metadata[format].srcSet
            },
            format
          )),
          /* @__PURE__ */ jsx(
            "img",
            {
              src: elem_metadata["fallback"],
              onError: (error) => {
                handleError(error, index);
              }
            }
          )
        ] });
      } else {
        if (images && props.render || frameworkID == "next") {
          return imageSlideElement(index);
        } else {
          return /* @__PURE__ */ jsx(
            "img",
            {
              className: `imageModal  ${fullImg && props.thumbnailImgAnim ? SlideshowLightbox_module_css_default.fullImg : false}   
           ${props.imgElemClassname ? props.imgElemClassname : ""}
          ${SlideshowLightbox_module_css_default.lightboxImg} 
          ${enableMagnifyingGlass ? SlideshowLightbox_module_css_default.maxWidthFull : SlideshowLightbox_module_css_default.maxWidthWithoutMagnifier} ${SlideshowLightbox_module_css_default.containImg} `,
              ref: imageRef,
              loading: "lazy",
              style: getImageStyle(),
              src: images && images[index].original ? images[index].original : images[index].src,
              onLoad: (img) => {
                if (displayImgMetadata) {
                  if (img) {
                    let img_target = img.target;
                    let individual_image_metadata = {};
                    let name = getImageFilename(img_target.src);
                    individual_image_metadata["name"] = name;
                    exifr.parse(img_target, true).then(
                      (exif) => {
                        if (exif) {
                          let keys = ["isoData", "createDate", "height", "width", "shutterSpeed", "fNumber"];
                          for (let i = 0; i < keys.length; i++) {
                            let keyName = keys[i];
                            switch (keyName) {
                              case "isoData":
                                if (exif.ISO) {
                                  individual_image_metadata["isoData"] = exif.ISO;
                                }
                                break;
                              case "createDate":
                                if (exif.CreateDate) {
                                  individual_image_metadata["createDate"] = parseCreateDate(exif.CreateDate);
                                }
                                break;
                              case "height":
                                if (exif.ExifImageHeight) {
                                  individual_image_metadata["height"] = exif.ExifImageHeight;
                                }
                                break;
                              case "width":
                                if (exif.ExifImageWidth) {
                                  individual_image_metadata["width"] = exif.ExifImageWidth;
                                }
                                break;
                              case "fNumber":
                                if (exif.fNumber) {
                                  individual_image_metadata["fNumber"] = exif.fNumber;
                                }
                                break;
                              case "shutterSpeed":
                                if (exif.ShutterSpeedValue) {
                                  individual_image_metadata["shutterSpeed"] = exif.ShutterSpeedValue;
                                }
                                break;
                            }
                          }
                          let imgMetadataItems = imgMetadata;
                          imgMetadataItems[index] = individual_image_metadata;
                          setImgMetadata(imgMetadataItems);
                          if (index == slideIndex) {
                            setIsLoading(false);
                          }
                        }
                      }
                    );
                  }
                }
                if (index == slideIndex) {
                  setDisplayLoader(false);
                }
                if (props.images) {
                  setItemLoaded(index);
                } else {
                  setImagesItemLoaded(index);
                }
              },
              id: "img"
            },
            index
          );
        }
      }
    };
    const isCustomEmbed = (index) => {
      if (props.images) {
        let elem = props.images[index];
        if (elem) {
          if (elem.type == "customEmbed") {
            return true;
          }
        }
      }
      return false;
    };
    const isVideo = (index) => {
      if (props.images) {
        let elem = props.images[index];
        if (elem) {
          if (elem.type == "yt" || elem.type == "htmlVideo" || elem.type == "customVideoEmbed") {
            return true;
          }
        }
      }
      return false;
    };
    const shouldDisplayMetadataPanel = () => {
      if (isMobile) {
        if (showImgMetadataPanel) {
          return true;
        } else {
          return false;
        }
      } else {
        return displayImgMetadata;
      }
    };
    const isPictureElement = (index) => {
      if (props.images) {
        let elem = props.images[index];
        if (elem) {
          if (elem.picture) {
            return true;
          }
        }
      }
      return false;
    };
    useEffect2(() => {
      if (!emblaApi)
        return;
      if (imgAnimation == "fade") {
        emblaApi.internalEngine().translate.toggleActive(false);
      }
    }, [
      carouselReady,
      emblaApi
    ]);
    const isHTMLVideo = (index) => {
      if (props.images) {
        if (props.images && props.images[index].type == "htmlVideo") {
          return true;
        }
      }
      return false;
    };
    const videoSlideElement = (index) => {
      let elem = props.images[index];
      let videoElem;
      if (elem.type == "yt") {
        videoElem = /* @__PURE__ */ jsx("div", { className: `${SlideshowLightbox_module_css_default.videoOuterContainer} imageModal`, children: /* @__PURE__ */ jsx(
          YouTube,
          {
            videoId: elem.videoID,
            ref: (el) => videoReferences.current[index] = el,
            iframeClassName: `${SlideshowLightbox_module_css_default.ytVideo}`,
            title: "YouTube video player",
            opts: {
              height: getVideoHeight(elem),
              width: getVideoWidth(elem),
              playerVars: {
                autoplay: shouldAutoplay(elem) ? 1 : 0
              }
            },
            onReady: (event) => {
              let videoElems = videoElements;
              videoElems[index] = event;
              setVideoElements(videoElems);
              if (index == slideIndex) {
                setDisplayLoader(false);
              }
              setItemLoaded(index);
            },
            onPlay: (event) => {
              setYTVideoCurrentlyPlaying(true);
            },
            onPause: (event) => {
              setYTVideoCurrentlyPlaying(false);
            },
            onEnd: (event) => {
              setYTVideoCurrentlyPlaying(false);
            },
            onError: (event) => {
              handleError(event, index);
            },
            onStateChange: (event) => {
            },
            onPlaybackRateChange: (event) => {
            },
            onPlaybackQualityChange: (event) => {
            }
          }
        ) });
      } else if (elem.type == "htmlVideo") {
        videoElem = /* @__PURE__ */ jsx(
          "div",
          {
            className: `${SlideshowLightbox_module_css_default.htmlVideo} ${SlideshowLightbox_module_css_default.htmlVideoOuterContainer} imageModal`,
            children: /* @__PURE__ */ jsx(
              "video",
              {
                className: `${SlideshowLightbox_module_css_default.cursorPointer} ${SlideshowLightbox_module_css_default.lightboxVideo}`,
                width: getVideoWidth(elem),
                ref: (el) => videoReferences.current[index] = el,
                onPlay: () => {
                },
                onError: (event) => {
                  handleError(event, index);
                },
                height: getVideoHeight(elem),
                autoPlay: index == imgSlideIndex ? shouldAutoplay(elem) : false,
                controls: true,
                children: /* @__PURE__ */ jsx(
                  "source",
                  {
                    src: elem.videoSrc,
                    type: "video/mp4",
                    onLoad: () => {
                      setItemLoaded(index);
                    }
                  }
                )
              }
            )
          }
        );
      } else if (elem.type == "customVideoEmbed") {
        videoElem = /* @__PURE__ */ jsx("div", { className: `${SlideshowLightbox_module_css_default.customVideoContainer} imageModal`, children: elem.embed });
      }
      return videoElem;
    };
    const customEmbedElement = (index) => {
      let elem = props.images[index];
      let customElem;
      if (elem.type == "customEmbed") {
        customElem = /* @__PURE__ */ jsx("div", { className: `${SlideshowLightbox_module_css_default.customEmbedContainer} imageModal`, children: elem.embed });
      }
      return customElem;
    };
    const initZoom = (ref2) => {
      if (imgAnimation == "fade") {
        if (ref2.state.scale <= 1) {
          setZoomedIn(false);
        } else {
          setZoomedIn(true);
        }
      } else {
        if (ref2.state.scale <= 1.65) {
          setZoomedIn(false);
        } else {
          setZoomedIn(true);
        }
      }
    };
    const regularImgPaneNodes = Array.apply(null, Array(images.length)).map(
      (_, index) => {
        return /* @__PURE__ */ jsx("div", { className: `${props.fullScreen ? SlideshowLightbox_module_css_default.fullScreenContainer : null}`, children: enableMagnifyingGlass == true ? /* @__PURE__ */ jsx("div", {}) : /* @__PURE__ */ jsx(
          "div",
          {
            className: getEmblaClass(index),
            onTouchStart,
            onTouchMove,
            onTouchEnd,
            onMouseDown,
            onMouseUp,
            children: /* @__PURE__ */ jsx(
              TransformWrapper,
              {
                ref: (el) => zoomReferences.current[index] = el,
                onWheel: (ref2, wheelEvent) => {
                  initZoom(ref2);
                },
                disabled: disableZoom,
                panning: {
                  disabled: isPanningDisabled()
                },
                onZoom: (ref2, event) => {
                  initZoom(ref2);
                },
                onZoomStop: (ref2, event) => {
                  initZoom(ref2);
                },
                onTransformed: (ref2, event) => {
                  initZoom(ref2);
                },
                onPinchingStop: (ref2, event) => {
                  initZoom(ref2);
                },
                centerZoomedOut: true,
                initialScale: 1,
                maxScale,
                alignmentAnimation: { sizeX: 0, sizeY: 0 },
                children: /* @__PURE__ */ jsx(
                  TransformComponent,
                  {
                    wrapperClass: SlideshowLightbox_module_css_default.reactTransformWrapper,
                    contentClass: SlideshowLightbox_module_css_default.reactTransformComponent,
                    wrapperStyle: {
                      maxWidth: "100vw",
                      height: "100vh",
                      margin: "auto"
                    },
                    contentStyle: {
                      maxWidth: "100vw",
                      height: "100vh",
                      margin: "auto",
                      display: "grid"
                    },
                    children: /* @__PURE__ */ jsx(
                      "div",
                      {
                        className: `${SlideshowLightbox_module_css_default.slideshowImg} ${props.lightboxImgClass ? props.lightboxImgClass : ""}
                      ${displayImgMetadata ? SlideshowLightbox_module_css_default.slideshowImgMetadata : ""}
                      `,
                        children: getLightboxElem(index)
                      }
                    )
                  },
                  index
                )
              },
              index
            )
          }
        ) }, index);
      }
    );
    const initMagnifyingGlass = () => {
      if (!enableMagnifyingGlass) {
        initImageDimensions();
      } else {
        setImgAnimation("imgDrag");
      }
      setMagnifyingGlass(!enableMagnifyingGlass);
    };
    const getMetadataPanelStyle = () => {
      let style_object = {};
      if (isMobile && showImgMetadataPanel) {
        style_object = { height: "100vh" };
      }
      style_object["color"] = getMetadataTextColor();
      return style_object;
    };
    const initImageDimensions = () => {
      let img;
      if (imgSlideIndex == 0 || imgSlideIndex % images.length == 0) {
        img = document.getElementById("img");
      } else {
        img = imageRef.current;
      }
      var ratio = img.naturalWidth / img.naturalHeight;
      var width2 = img.height * ratio;
      var height = img.height;
      if (width2 > img.width) {
        width2 = img.width;
        height = img.width / ratio;
      }
      setImgContainHeight(height);
      setImgContainWidth(width2);
    };
    const initFullScreenChangeEventListeners = () => {
      document.addEventListener("fullscreenchange", exitFullScreenHandler);
      document.addEventListener("webkitfullscreenchange", exitFullScreenHandler);
      document.addEventListener("MSFullscreenChange", exitFullScreenHandler);
      document.addEventListener("mozfullscreenchange", exitFullScreenHandler);
    };
    const removeFullScreenChangeEventListeners = () => {
      document.removeEventListener("fullscreenchange", exitFullScreenHandler);
      document.removeEventListener(
        "webkitfullscreenchange",
        exitFullScreenHandler
      );
      document.removeEventListener("MSFullscreenChange", exitFullScreenHandler);
      document.removeEventListener("mozfullscreenchange", exitFullScreenHandler);
    };
    const initEventListeners = () => {
      if (isBrowser() && !noWindow) {
        window.addEventListener("resize", handleWindowResize);
      }
    };
    const removeEventListeners = () => {
      removeOnSelectListener();
      if (isBrowser() && !noWindow) {
        window.removeEventListener("resize", handleWindowResize);
      }
    };
    const setReducedMotion = (mediaQuery) => {
      if (mediaQuery.matches) {
        setImgAnimation("fade");
      }
    };
    const checkAndInitReducedMotion = () => {
      let reducedMotionMediaQuery = "";
      if (isBrowser() && !noWindow) {
        reducedMotionMediaQuery = window.matchMedia(
          "(prefers-reduced-motion: reduce)"
        );
        if (!reducedMotionMediaQuery || reducedMotionMediaQuery.matches) {
          setImgAnimation("fade");
        }
        if (reducedMotionMediaQuery?.addEventListener) {
          reducedMotionMediaQuery.addEventListener("change", setReducedMotion(reducedMotionMediaQuery));
        } else {
          reducedMotionMediaQuery.addListener(setReducedMotion(reducedMotionMediaQuery));
        }
      }
      return reducedMotionMediaQuery;
    };
    const initPropsForControlIcons = () => {
      if (props.showFullScreenIcon != void 0) {
        setDisplayFullScreenIcon(props.showFullScreenIcon);
      }
      if (props.showThumbnailIcon != void 0) {
        setDisplayThumbnailIcon(props.showThumbnailIcon);
      }
      if (props.showSlideshowIcon != void 0) {
        setDisplaySlideshowIcon(props.showSlideshowIcon);
      }
      if (props.showMagnificationIcons != void 0) {
        setDisplayMagnificationIcons(props.showMagnificationIcons);
      }
    };
    const initProps = () => {
      if (props.showControls != void 0) {
        setShowControls(props.showControls);
        if (props.showControls == false) {
          setDisplayMagnificationIcons(false);
        }
      }
      if (props.disableAnim == true) {
        MotionGlobalConfig.skipAnimations = true;
      }
      initPropsForControlIcons();
      if (props.disableImageZoom) {
        setDisableZoom(props.disableImageZoom);
      }
      if (isBrowser() && !noWindow) {
        setWidth(window.innerWidth);
      }
    };
    useInterval(
      () => {
        if (isRTL) {
          updateImageSlideshow(-1);
        } else {
          updateImageSlideshow(1);
        }
      },
      isSlideshowPlaying ? slideshowInterval : null
    );
    const openFullScreen = (lightbox_elem) => {
      if (lightbox_elem.requestFullscreen) {
        lightbox_elem.requestFullscreen();
      } else if (lightbox_elem.webkitRequestFullscreen) {
        lightbox_elem.webkitRequestFullscreen();
      } else if (lightbox_elem.msRequestFullscreen) {
        lightbox_elem.msRequestFullscreen();
      }
    };
    const closeFullScreen = (document2) => {
      if (document2.exitFullscreen) {
        document2.exitFullscreen();
      } else if (document2.webkitExitFullscreen) {
        document2.webkitExitFullscreen();
      } else if (document2.msExitFullscreen) {
        document2.msExitFullscreen();
      }
    };
    const isBrowser = () => {
      if (!noWindow) {
        return typeof window !== "undefined";
      }
      return false;
    };
    const initRTLImages = () => {
      let imagesMetadataCopy = props.images;
      imagesMetadataCopy.reverse();
      setImages(imagesMetadataCopy);
      if (images.length > 0) {
        let imagesRTLCopy = images;
        imagesRTLCopy.reverse();
        setImages(imagesRTLCopy);
      }
    };
    const initAndOpenLightbox = (i, img_gallery, isMounted) => {
      let index;
      if (isRTL) {
        index = getRTLIndex(img_gallery.length, i);
      } else {
        index = i;
      }
      let reactSwipeOptionConfig = reactSwipeOptions;
      reactSwipeOptionConfig.startIndex = index;
      if (isMounted)
        setReactSwipeOptions(reactSwipeOptionConfig);
      setZoomIdx(index);
      openModal(index);
    };
    const initImages = (isMounted, updateImages) => {
      if (coverMode && props.images) {
        if (props.coverImageInLightbox == false) {
          let filterImages = props.images.filter((img) => img.cover != true);
          setImages(filterImages);
        } else {
          setImages(props.images);
        }
      }
      if (updateImages || !isInit) {
        if (lightboxIdentifier && props.children) {
          if (props.queryElems) {
            let img_gallery = [];
            for (let k = 0; k < props.queryElems.length; k++) {
              let elemSelector = props.queryElems[k];
              let queryElems = document.querySelectorAll(
                `${elemSelector}`
              );
              queryElems.forEach((element) => {
                img_gallery.push(element);
              });
            }
            let img_elements = [];
            if (img_gallery.length > 0) {
              for (let i = 0; i <= img_gallery.length - 1; i++) {
                let img = img_gallery[i];
                img.addEventListener(
                  "click",
                  () => {
                    initAndOpenLightbox(i, img_gallery, isMounted);
                  },
                  false
                );
                img.classList.add("cursor-pointer");
                if (img.src) {
                  img_elements.push({
                    src: img.src,
                    alt: img.alt,
                    loaded: false
                  });
                } else if (img.href) {
                  img_elements.push({
                    src: img.href,
                    alt: img.alt,
                    loaded: false
                  });
                }
              }
              if (isMounted && !coverMode) {
                if (props.framework != "next") {
                  setImages(img_elements);
                } else if (props.framework == "next") {
                  setImages(props.images);
                }
              }
            }
          } else {
            let img_gallery = document.querySelectorAll(
              `[data-lightboxjs=${lightboxIdentifier}]`
            );
            let originalImageAttr = false;
            let img_elements = [];
            if (img_gallery.length > 0) {
              for (let i = 0; i <= img_gallery.length - 1; i++) {
                let img = img_gallery[i];
                let attr_val = img.getAttribute("data-lightboxjs");
                if (attr_val == lightboxIdentifier) {
                  img.addEventListener(
                    "click",
                    () => {
                      initAndOpenLightbox(i, img_gallery, isMounted);
                    },
                    false
                  );
                  img.classList.add("cursor-pointer");
                  let original_img_src = img.getAttribute("data-lightboxjs-original");
                  if (original_img_src) {
                    img_elements.push({
                      src: original_img_src,
                      alt: img.alt,
                      loaded: false
                    });
                    originalImageAttr = true;
                  } else if (img.src) {
                    img_elements.push({
                      src: img.src,
                      alt: img.alt,
                      loaded: false
                    });
                  } else if (img.tagName == "DIV") {
                    let corresponding_img_item = props.images[i];
                    let img_src = corresponding_img_item.src;
                    let img_alt = corresponding_img_item.alt;
                    img_elements.push({
                      src: img_src,
                      alt: img_alt,
                      loaded: false
                    });
                  }
                }
              }
              if (isMounted && !coverMode) {
                if (originalImageAttr) {
                  setImages(img_elements);
                } else if (props.showAllImages != true && props.framework != "next") {
                  setImages(img_elements);
                } else if (props.framework == "next" && !originalImageAttr) {
                  setImages(props.images);
                } else {
                  setImages(props.images);
                }
              }
            } else {
              if (props.images) {
                setImages(props.images);
              }
            }
          }
        } else if (lightboxIdentifier && props.images && !props.children) {
          setImages(props.images);
        } else if (!lightboxIdentifier && props.images && !props.children) {
          setImages(props.images);
        } else if (!props.render) {
          let imgArray = [];
          if (!Array.isArray(props.children)) {
            imgArray.push(props.children);
          } else {
            imgArray = props.children;
          }
          let imgs = [];
          for (let k = 0; k < imgArray.length; k++) {
            let img_elem = imgArray[k];
            let img_obj = {
              src: img_elem.props.src,
              alt: img_elem.props.alt,
              loaded: false
            };
            imgs.push(img_obj);
          }
          if (isRTL) {
            imgs.reverse();
          }
          if (isMounted)
            setImages(imgs);
          setPreviewImageElems(imgArray);
        } else {
          if (isMounted) {
            setImages(props.images);
          }
        }
        if (isMounted)
          setIsInit(true);
      }
    };
    const dispatchSlideSelectEvents = (newIndex, prevIndex) => {
      if (props.onSelect) {
        props.onSelect(newIndex, images[newIndex]);
      }
      if (newIndex == 0 && prevIndex == images.length - 1) {
        dispatchNextImgEvent(newIndex);
      } else if (newIndex == images.length - 1 && prevIndex == 0) {
        dispatchPrevImgEvent(newIndex);
      } else if (newIndex > prevIndex) {
        dispatchNextImgEvent(newIndex);
      } else if (newIndex < prevIndex) {
        dispatchPrevImgEvent(newIndex);
      }
    };
    const onSelect = useCallback2(() => {
      if (!emblaApi)
        return;
      let newSlideIndex = emblaApi.selectedScrollSnap();
      let prevSlideIndex = emblaApi.previousScrollSnap();
      if (newSlideIndex != prevSlideIndex) {
        initSlide(newSlideIndex);
        resetMedia(prevSlideIndex);
        dispatchSlideSelectEvents(newSlideIndex, prevSlideIndex);
      }
      if (emblaThumbsApi) {
        emblaThumbsApi.scrollTo(emblaApi.selectedScrollSnap());
      }
    }, [emblaApi, emblaThumbsApi]);
    const onReinit = useCallback2(() => {
      if (!emblaApi)
        return;
      setEmblaReinitialized(true);
    }, [emblaApi, emblaReinitialized]);
    const handleResize = (entry) => {
      emblaApi?.reInit();
    };
    const rootNode = emblaApi?.rootNode() || null;
    if (isBrowser() && !noWindow) {
      useResizeObserver(rootNode, handleResize);
    }
    const removeOnSelectListener = useCallback2(() => {
      if (emblaApi)
        emblaApi.off("select", onSelect);
    }, [emblaApi, onSelect]);
    useEffect2(() => {
      if (emblaApi) {
        if (zoomedIn) {
          emblaApi.reInit({ watchDrag: false });
        } else {
          emblaApi.reInit({ watchDrag: true });
        }
      }
    }, [zoomedIn]);
    useEffect2(() => {
      if (displayImgMetadata) {
        if (width != 0 && isMobile) {
          setShowImgMetadataPanel(false);
        } else {
          setShowImgMetadataPanel(true);
        }
      }
    }, [width]);
    useEffect2(() => {
      if (!emblaApi)
        return;
      if (showModal)
        emblaApi.reInit();
    }, [showModal, emblaApi]);
    useEffect2(() => {
      if (emblaApi)
        emblaApi.on("select", onSelect);
      if (emblaApi) {
      }
    }, [emblaApi, onSelect]);
    useEffect2(() => {
      if (emblaApi)
        emblaApi.on("reInit", onReinit);
    }, [emblaApi, onReinit]);
    useEffect2(() => {
      initStyling();
      if (props.iconColor) {
        setIconColor(props.iconColor);
      }
      if (props.backgroundColor) {
        setBackgroundColor(props.backgroundColor);
      }
    }, [props.theme, props.iconColor, props.backgroundColor]);
    useEffect2(() => {
      initImages(true, true);
    }, [props.images, props.displayedImages]);
    const prevValue = usePrevious(open);
    const prevImages = usePrevious(images);
    const areObjectsEqual = (object1, object2) => typeof object1 === "object" && object1 != null && typeof object2 === "object" && object2 != null && Object.keys(object1).length > 0 ? Object.keys(object1).length === Object.keys(object2).length && Object.keys(object1).every((p) => areObjectsEqual(object1[p], object2[p])) : object1 === object2;
    const imagesEqualToPrevious = (images2) => {
      if (images2 && prevImages) {
        if ((images2 && images2?.length) != (prevImages && prevImages?.length)) {
          return false;
        }
        let imgArray;
        if (images2.length > prevImages) {
          imgArray = images2;
        } else {
          imgArray = prevImages;
        }
        for (let i = 0; i < imgArray.length; i++) {
          let images_copy = images2.slice(0);
          let prevImages_copy = prevImages.slice(0);
          let image = images_copy[i];
          let prevImage = prevImages_copy[i];
          if (image["loaded"]) {
            delete image["loaded"];
          }
          if (prevImage["loaded"]) {
            delete prevImage["loaded"];
          }
          if (!areObjectsEqual(image, prevImage)) {
            return false;
          }
        }
      }
      return true;
    };
    useEffect2(() => {
      let starting_index = 0;
      if (props.startingSlideIndex) {
        starting_index = wrapNums(0, images.length, props.startingSlideIndex);
        setStartingIndex(starting_index);
      }
      if (props.open == true && imagesEqualToPrevious(images) == false && props.startingSlideIndex) {
        if (props.images) {
          setImages(props.images);
        }
        openModalWithSlideNum(starting_index);
      } else if (props.open && prevValue != true) {
        if (props.images) {
          setImages(props.images);
        }
        setIsDisplay(true);
        openModalWithSlideNum(starting_index);
      } else if (props.open == false) {
        setIsDisplay(false);
        closeModal();
      }
    }, [props.open, props.startingSlideIndex, images]);
    useEffect2(() => {
      if (isOpen == true) {
        dispatchOpenEvent();
      } else {
        dispatchCloseEvent();
      }
    }, [isOpen]);
    useEffect2(() => {
      if (props.render) {
        if (!props.images) {
          console.error(
            "Array of images must be passed to `SlideshowLightbox` (with the `images` prop) if using custom render method. "
          );
        }
      }
      let isMounted = true;
      if (isMounted)
        initProps();
      if (window) {
        const userAgent = window.navigator.userAgent.toLowerCase();
        let is_tablet_useragent = /(ipad|iphone|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);
        let is_ipad_useragent = /Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1;
        setIsTabletUserAgent(is_tablet_useragent || is_ipad_useragent);
      }
      if (coverMode && props.images) {
        if (props.coverImageInLightbox == false) {
          let filterImages = props.images.filter((img) => img.cover != true);
          setImages(filterImages);
        } else {
          setImages(props.images);
        }
      }
      if (isMounted) {
        initEventListeners();
      }
      let reducedMotionMediaQuery = checkAndInitReducedMotion();
      if (displayImgMetadata) {
        setImgAnimation("fade");
      }
      if (!isInit) {
        initImages(isMounted, false);
        if (props.images && isRTL == true) {
          initRTLImages();
        }
      }
      if (isMounted)
        initStyling();
      return () => {
        isMounted = false;
        removeEventListeners();
        if (reducedMotionMediaQuery) {
          reducedMotionMediaQuery.removeEventListener(
            "change",
            reducedMotionMediaQuery
          );
        }
      };
    }, []);
    const renderPreviewImages = () => {
      let image_elems;
      if (props.images && props.children && lightboxIdentifier == false) {
        image_elems = props.children;
      } else if (props.images && lightboxIdentifier == false) {
        image_elems = props.images.map((elem, index) => /* @__PURE__ */ jsx(
          "img",
          {
            className: `${props.imgClassName ? props.imgClassName : ""} ${SlideshowLightbox_module_css_default.cursorPointer}`,
            src: !isVideo(index) ? elem.src : elem.thumbnail,
            onClick: () => {
              let img_index;
              if (isRTL) {
                img_index = getRTLIndex(props.images.length, index);
              } else {
                img_index = index;
              }
              openModalWithSlideNum(img_index);
            }
          },
          index
        ));
      } else if (lightboxIdentifier != false && props.children && coverMode == false) {
        {
        }
        image_elems = props.children;
      } else if (!(lightboxIdentifier == false && props.images || coverMode == true)) {
        image_elems = previewImageElems.filter((elem) => elem.type == "img").map((elem, index) => /* @__PURE__ */ createElement(
          "img",
          {
            ...elem.props,
            className: `${elem.props.className ? elem.props.className : ""} ${SlideshowLightbox_module_css_default.cursorPointer}`,
            onClick: () => {
              let img_index;
              if (isRTL) {
                img_index = getRTLIndex(previewImageElems.length, index);
              } else {
                img_index = index;
              }
              openModalWithSlideNum(img_index);
            },
            key: index
          }
        ));
      } else if (coverMode) {
        image_elems = props.children;
      }
      return image_elems;
    };
    return /* @__PURE__ */ jsxs2("div", { className: `${initWrapperClassname()}`, children: [
      renderPreviewImages(),
      /* @__PURE__ */ jsx(AnimatePresence, { initial: false, mode: "wait", children: showModal !== false && /* @__PURE__ */ jsx(Portal, { children: /* @__PURE__ */ jsx(Div100vh, { children: /* @__PURE__ */ jsxs2(
        motion.div,
        {
          className: `${SlideshowLightbox_module_css_default.modalContainer}`,
          initial: "inactive",
          variants,
          animate: showModal ? "active" : "inactive",
          exit: "inactive",
          transition: { duration: "0.3" },
          onAnimationComplete: () => {
            let animEntered = !animationEntered;
            setAnimationEntered(animEntered);
            if (animEntered == true) {
              let prevFocusedElement = document.activeElement;
              setPrevFocusedElem(prevFocusedElement);
              document.getElementById("lightboxContainer")?.focus();
            } else {
              prevFocusedElem?.focus();
            }
            if (emblaApi)
              emblaApi.reInit();
          },
          children: [
            /* @__PURE__ */ jsx(
              motion.div,
              {
                className: `${SlideshowLightbox_module_css_default.slideshowAnimContainer} `,
                id: "slideshowAnim",
                style: {
                  backgroundColor,
                  width: lightboxModalWidth
                },
                children: /* @__PURE__ */ jsxs2(
                  "div",
                  {
                    className: `${SlideshowLightbox_module_css_default.lightboxContainer} `,
                    id: "lightboxContainer",
                    tabIndex: -1,
                    role: "dialog",
                    onClick: (e) => {
                      if (modalCloseOption == "clickOutside") {
                        checkModalClick(e);
                      }
                    },
                    children: [
                      /* @__PURE__ */ jsxs2(
                        "section",
                        {
                          className: `${SlideshowLightbox_module_css_default.iconsHeader} ${iconColor ? "" : getIconStyle()} imageModal`,
                          style: { color: iconColor },
                          children: [
                            /* @__PURE__ */ jsx(
                              KeyHandler,
                              {
                                keyValue: "ArrowLeft",
                                code: "37",
                                onKeyHandle: () => {
                                  prevSlide();
                                }
                              }
                            ),
                            /* @__PURE__ */ jsx(
                              KeyHandler,
                              {
                                keyValue: "ArrowRight",
                                code: "39",
                                onKeyHandle: () => {
                                  nextSlide();
                                }
                              }
                            ),
                            /* @__PURE__ */ jsx(
                              KeyHandler,
                              {
                                keyValue: "Escape",
                                code: "27",
                                onKeyHandle: (event) => {
                                  event.preventDefault();
                                  event.stopPropagation();
                                  if (!isBrowserFullScreen) {
                                    closeModal();
                                  }
                                }
                              }
                            ),
                            /* @__PURE__ */ jsx(
                              KeyHandler,
                              {
                                keyValue: "Left",
                                code: "37",
                                onKeyHandle: () => {
                                  prevSlide();
                                }
                              }
                            ),
                            /* @__PURE__ */ jsx(
                              KeyHandler,
                              {
                                keyValue: "Right",
                                code: "39",
                                onKeyHandle: () => {
                                  nextSlide();
                                }
                              }
                            ),
                            /* @__PURE__ */ jsx(
                              KeyHandler,
                              {
                                keyValue: "Esc",
                                code: "27",
                                onKeyHandle: (event) => {
                                  event.preventDefault();
                                  event.stopPropagation();
                                  if (!isBrowserFullScreen) {
                                    closeModal();
                                  }
                                }
                              }
                            ),
                            showControls == true && /* @__PURE__ */ jsxs2("div", { className: `${SlideshowLightbox_module_css_default.controls}`, children: [
                              disableZoom || displayMagnificationIcons == false ? null : /* @__PURE__ */ jsx(motion.div, { children: /* @__PURE__ */ jsx("button", { onClick: () => {
                                if (enableMagnifyingGlass) {
                                  initMagnifyingGlass();
                                }
                                if (zoomReferences.current[zoomIdx] != null) {
                                  zoomReferences.current[zoomIdx].zoomIn();
                                }
                                setZoomedIn(true);
                              }, children: /* @__PURE__ */ jsx(
                                ZoomIn,
                                {
                                  size: 24,
                                  color: iconColor ? iconColor : void 0,
                                  className: `${SlideshowLightbox_module_css_default.lightboxjsIcon} ${iconColor ? "" : getIconStyle()}`,
                                  style: iconColor ? { color: iconColor } : {}
                                }
                              ) }) }),
                              disableZoom || displayMagnificationIcons == false ? null : /* @__PURE__ */ jsx(motion.div, { children: /* @__PURE__ */ jsx(
                                "button",
                                {
                                  onClick: () => {
                                    zoomReferences.current[zoomIdx].zoomOut();
                                    let scale = zoomReferences.current[zoomIdx].state.scale;
                                    if (scale == 1 || scale == 1.65) {
                                      setZoomedIn(false);
                                    }
                                  },
                                  children: /* @__PURE__ */ jsx(
                                    ZoomOut,
                                    {
                                      size: 24,
                                      className: `${SlideshowLightbox_module_css_default.lightboxjsIcon} ${iconColor ? "" : getIconStyle()}`,
                                      style: iconColor ? { color: iconColor } : {},
                                      color: iconColor ? iconColor : void 0
                                    }
                                  )
                                }
                              ) }),
                              displayDownloadBtn() ? /* @__PURE__ */ jsx(
                                "button",
                                {
                                  onClick: () => {
                                    saveImage();
                                  },
                                  children: /* @__PURE__ */ jsx(
                                    Download,
                                    {
                                      size: 24,
                                      className: `${SlideshowLightbox_module_css_default.lightboxjsIcon} ${iconColor ? "" : getIconStyle()}`,
                                      style: iconColor ? { color: iconColor } : {},
                                      color: iconColor ? iconColor : void 0
                                    }
                                  )
                                }
                              ) : null,
                              displayFullScreenIcon ? isBrowserFullScreen ? /* @__PURE__ */ jsx(motion.div, { children: /* @__PURE__ */ jsx(
                                "button",
                                {
                                  onClick: () => {
                                    isBrowserFullScreen ? exitFullScreen() : fullScreen();
                                  },
                                  children: /* @__PURE__ */ jsx(
                                    FullscreenExit,
                                    {
                                      size: 24,
                                      className: `${SlideshowLightbox_module_css_default.lightboxjsIcon} ${iconColor ? "" : getIconStyle()}`,
                                      style: iconColor ? { color: iconColor } : {},
                                      color: iconColor ? iconColor : void 0
                                    }
                                  )
                                }
                              ) }) : /* @__PURE__ */ jsx(motion.div, { children: /* @__PURE__ */ jsx("button", { onClick: () => {
                                isBrowserFullScreen ? exitFullScreen() : fullScreen();
                              }, children: /* @__PURE__ */ jsx(
                                Fullscreen,
                                {
                                  size: 24,
                                  className: `${SlideshowLightbox_module_css_default.lightboxjsIcon} ${iconColor ? "" : getIconStyle()}`,
                                  style: iconColor ? { color: iconColor } : {},
                                  color: iconColor ? iconColor : void 0
                                }
                              ) }) }) : null,
                              isMobile && displayImgMetadata ? /* @__PURE__ */ jsx(motion.div, { children: /* @__PURE__ */ jsx("button", { onClick: () => {
                                setShowImgMetadataPanel(!showImgMetadataPanel);
                                setDisplayLoader(false);
                              }, children: /* @__PURE__ */ jsx(
                                InfoCircle,
                                {
                                  size: 24,
                                  className: `${SlideshowLightbox_module_css_default.lightboxjsIcon} ${iconColor ? "" : getIconStyle()}`,
                                  style: iconColor ? { color: iconColor } : {},
                                  color: iconColor ? iconColor : void 0
                                }
                              ) }) }) : null,
                              displayThumbnailIcon ? /* @__PURE__ */ jsx(motion.div, { children: /* @__PURE__ */ jsx(
                                "button",
                                {
                                  onClick: () => {
                                    setShowThumbnails(!showThumbnails);
                                    setFullImg(!fullImg);
                                  },
                                  children: /* @__PURE__ */ jsx(
                                    GridFill,
                                    {
                                      size: 24,
                                      className: `${SlideshowLightbox_module_css_default.lightboxjsIcon} ${iconColor ? "" : getIconStyle()}`,
                                      style: iconColor ? { color: iconColor } : {},
                                      color: iconColor ? iconColor : void 0
                                    }
                                  )
                                }
                              ) }) : null,
                              shouldDisplayMagnifyingGlassIcon() ? /* @__PURE__ */ jsx(motion.div, { children: /* @__PURE__ */ jsx(
                                "button",
                                {
                                  onClick: () => initMagnifyingGlass(),
                                  children: /* @__PURE__ */ jsx(
                                    Search,
                                    {
                                      size: 24,
                                      className: `${SlideshowLightbox_module_css_default.lightboxjsIcon} ${iconColor ? "" : getIconStyle()}`,
                                      style: iconColor ? { color: iconColor } : {},
                                      color: iconColor ? iconColor : void 0
                                    }
                                  )
                                }
                              ) }) : null,
                              shouldDisplaySlideshowIcon() ? /* @__PURE__ */ jsx(motion.div, { className: SlideshowLightbox_module_css_default.slideshowPlayBtn, children: isSlideshowPlaying ? /* @__PURE__ */ jsx("button", { onClick: () => {
                                isSlideshowPlaying ? stopSlideshow() : playSlideshow();
                              }, children: /* @__PURE__ */ jsx(
                                PauseCircleFill,
                                {
                                  size: 24,
                                  className: `${SlideshowLightbox_module_css_default.lightboxjsIcon} ${iconColor ? "" : getIconStyle()}`,
                                  style: iconColor ? { color: iconColor } : {},
                                  color: iconColor ? iconColor : void 0
                                }
                              ) }) : /* @__PURE__ */ jsx("button", { onClick: () => {
                                isSlideshowPlaying ? stopSlideshow() : playSlideshow();
                              }, children: /* @__PURE__ */ jsx(
                                PlayCircleFill,
                                {
                                  size: 24,
                                  className: `${SlideshowLightbox_module_css_default.lightboxjsIcon} ${iconColor ? "" : getIconStyle()}`,
                                  style: iconColor ? { color: iconColor } : {},
                                  color: iconColor ? iconColor : void 0
                                }
                              ) }) }) : null,
                              customControlComponent ? /* @__PURE__ */ jsx(motion.div, { children: customControlComponent }) : null
                            ] }),
                            /* @__PURE__ */ jsx(motion.div, { className: `${SlideshowLightbox_module_css_default.closeIcon} ${props.showControls == false ? SlideshowLightbox_module_css_default.mlAuto : ""}`, children: /* @__PURE__ */ jsx(
                              "button",
                              {
                                id: "closeBtn",
                                className: `${props.showControlsBar == false && props.showControls == false ? SlideshowLightbox_module_css_default.closeButtonRounded : SlideshowLightbox_module_css_default.closeButton}`,
                                onClick: () => {
                                  closeModal();
                                },
                                children: /* @__PURE__ */ jsx(
                                  XLg,
                                  {
                                    id: "closeIcon",
                                    size: 24,
                                    className: `${SlideshowLightbox_module_css_default.lightboxjsIcon} ${iconColor ? "" : getIconStyle()}`,
                                    color: iconColor ? iconColor : void 0,
                                    style: getCloseIconBtnStyle()
                                  }
                                )
                              }
                            ) })
                          ]
                        }
                      ),
                      displayArrows() ? /* @__PURE__ */ jsxs2("div", { children: [
                        /* @__PURE__ */ jsx(
                          "div",
                          {
                            className: rightArrowStyle ? `${SlideshowLightbox_module_css_default.next1} ${getArrowStyle()} imageModal` : "imageModal",
                            style: rightArrowStyle,
                            onClick: () => {
                              nextSlide();
                            },
                            children: nextArrowElem ? nextArrowElem : /* @__PURE__ */ jsx("span", { className: `${props.rightArrowClassname ? props.rightArrowClassname : ""}`, children: "\u276F" })
                          }
                        ),
                        /* @__PURE__ */ jsx(
                          "div",
                          {
                            className: leftArrowStyle ? `${SlideshowLightbox_module_css_default.prev1} ${getArrowStyle()} imageModal ${displayImgMetadata ? SlideshowLightbox_module_css_default.prev1Metadata : ""}` : "imageModal",
                            style: leftArrowStyle,
                            onClick: () => {
                              prevSlide();
                            },
                            children: prevArrowElem ? prevArrowElem : /* @__PURE__ */ jsx("span", { className: `${props.leftArrowClassname ? props.leftArrowClassname : ""}`, children: "\u276E" })
                          }
                        )
                      ] }) : null,
                      /* @__PURE__ */ jsxs2(AnimatePresence, { initial: false, custom: direction, children: [
                        /* @__PURE__ */ jsxs2(
                          "div",
                          {
                            className: `${SlideshowLightbox_module_css_default.slideshowInnerContainerThumbnails} ${SlideshowLightbox_module_css_default.embla} ${isImageCaption() && showControlsBar == true ? SlideshowLightbox_module_css_default.slideImageAndCaption : ""} 
                          ${SlideshowLightbox_module_css_default.slideshowInnerContainer}
                          ${props.showControlsBar == false || props.fullScreen ? SlideshowLightbox_module_css_default.hideControlsBar : ""}
                          ${displayImgMetadata ? SlideshowLightbox_module_css_default.slideshowInnerContainerImgMetadata : ""}  `,
                            children: [
                              shouldDisplayMetadataPanel() ? /* @__PURE__ */ jsx(
                                "div",
                                {
                                  className: SlideshowLightbox_module_css_default.metadata,
                                  style: getMetadataPanelStyle(),
                                  children: isLoading ? null : /* @__PURE__ */ jsxs2("div", { className: SlideshowLightbox_module_css_default.metadataInnerContainer, children: [
                                    getMetadataPanel(),
                                    isMobile && showImgMetadataPanel ? /* @__PURE__ */ jsx(
                                      "button",
                                      {
                                        className: SlideshowLightbox_module_css_default.imgMetadataCloseBtn,
                                        onClick: () => {
                                          setShowImgMetadataPanel(false);
                                        },
                                        children: /* @__PURE__ */ jsx(
                                          XLg,
                                          {
                                            size: 24,
                                            className: `${SlideshowLightbox_module_css_default.lightboxjsIcon} ${iconColor ? "" : getIconStyle()}`,
                                            color: iconColor ? iconColor : void 0,
                                            style: iconColor ? { color: iconColor } : {}
                                          }
                                        )
                                      }
                                    ) : null
                                  ] })
                                }
                              ) : null,
                              /* @__PURE__ */ jsx(
                                "div",
                                {
                                  className: `${SlideshowLightbox_module_css_default.emblaViewport} 
                            ${displayImgMetadata ? SlideshowLightbox_module_css_default.emblaContainerImgMetadata : ""}`,
                                  ref: showModal ? emblaRef : null,
                                  children: /* @__PURE__ */ jsx("div", { className: `
                          ${imgAnimation == "fade" ? SlideshowLightbox_module_css_default.imgfade : ""} 
                          ${SlideshowLightbox_module_css_default.emblaContainer}
                            ${displayImgMetadata ? SlideshowLightbox_module_css_default.emblaContainerImgMetadata : ""}`, children: regularImgPaneNodes })
                                }
                              )
                            ]
                          }
                        ),
                        displayLoader == true && !isHTMLVideo(slideIndex) ? /* @__PURE__ */ jsx(
                          "span",
                          {
                            className: `${SlideshowLightbox_module_css_default.loader} ${getLoaderThemeClass()}`
                          },
                          "loader"
                        ) : null
                      ] }),
                      /* @__PURE__ */ jsxs2(
                        "div",
                        {
                          className: `${SlideshowLightbox_module_css_default.thumbnailsOuterContainer} ${isImageCaption() ? SlideshowLightbox_module_css_default.thumbnailsAndCaption : ""}
                      ${displayImgMetadata ? SlideshowLightbox_module_css_default.thumbnailsOuterContainerMetadata : ""} `,
                          style: getThumbnailsOuterContainerStyle(),
                          children: [
                            isImageCaption() ? /* @__PURE__ */ jsx("div", { className: `${SlideshowLightbox_module_css_default.imgTitleContainer} imageModal`, children: /* @__PURE__ */ jsx(
                              "p",
                              {
                                className: `${SlideshowLightbox_module_css_default.imgTitle}`,
                                style: props.captionStyle ? props.captionStyle : { color: textColor },
                                children: getImageCaption()
                              },
                              "imgCaption" + slideIndex
                            ) }) : null,
                            /* @__PURE__ */ jsxs2(AnimatePresence, { initial: animatedThumbnails, children: [
                              showThumbnails !== false && navigationDots !== true && /* @__PURE__ */ jsx(
                                motion.div,
                                {
                                  initial: "hidden",
                                  exit: "hidden",
                                  animate: "visible",
                                  style: imagesLoaded ? {} : { display: "displayHidden" },
                                  transition: {
                                    type: "spring",
                                    duration: 0.75
                                  },
                                  variants: thumbnailVariants,
                                  className: `${SlideshowLightbox_module_css_default.thumbnails} ${isImageCaption() ? SlideshowLightbox_module_css_default.thumbnailsWithCaption : ""}`,
                                  children: /* @__PURE__ */ jsx("div", { className: `${SlideshowLightbox_module_css_default.emblaThumbs} ${SlideshowLightbox_module_css_default.thumbnails}`, children: /* @__PURE__ */ jsx("div", { className: SlideshowLightbox_module_css_default.emblaThumbsViewport, ref: emblaThumbsRef, children: /* @__PURE__ */ jsx("div", { className: SlideshowLightbox_module_css_default.emblaThumbsContainer, children: frameworkID == "next" && props.images ? props.images.map((img, index) => getImageThumbnail(img, index, true, props)) : images.map((img, index) => getImageThumbnail(img, index, false, props)) }) }) })
                                }
                              ),
                              showThumbnails !== true && navigationDots !== false && /* @__PURE__ */ jsx(
                                motion.div,
                                {
                                  initial: "hidden",
                                  exit: "hidden",
                                  animate: "visible",
                                  style: imagesLoaded ? {} : { display: "displayHidden" },
                                  transition: {
                                    type: "spring",
                                    duration: 0.75
                                  },
                                  variants: thumbnailVariants,
                                  className: `${SlideshowLightbox_module_css_default.thumbnails} ${isImageCaption() ? SlideshowLightbox_module_css_default.thumbnailsWithCaption : ""}`,
                                  children: /* @__PURE__ */ jsx("div", { className: `${SlideshowLightbox_module_css_default.emblathumbs} ${SlideshowLightbox_module_css_default.thumbnails}`, children: /* @__PURE__ */ jsx("div", { className: SlideshowLightbox_module_css_default.emblaThumbsViewport, ref: emblaThumbsRef, children: /* @__PURE__ */ jsx("div", { className: `${SlideshowLightbox_module_css_default.navigationDots} ${SlideshowLightbox_module_css_default.emblaThumbsContainer} imageModal
                                `, children: frameworkID == "next" && props.images ? props.images.map((img, index) => getNavigationDot(index)) : images.map((img, index) => getNavigationDot(index)) }) }) })
                                }
                              )
                            ] })
                          ]
                        }
                      )
                    ]
                  }
                )
              },
              "slideshowAnimContainer"
            ),
            rightSidebarComponent
          ]
        }
      ) }) }) })
    ] });
  }
);

// lib/Image.tsx
import React2, { useEffect as useEffect3, useState as useState4 } from "react";
import { jsx as jsx2 } from "react/jsx-runtime";
var themes2 = {
  day: {
    background: "white",
    iconColor: "black",
    thumbnailBorder: "solid transparent 2px",
    textColor: "black"
  },
  night: {
    background: "#151515",
    iconColor: "silver",
    thumbnailBorder: "solid rgb(107, 133, 206)  2px",
    textColor: "silver"
  },
  lightbox: {
    background: "rgba(12, 12, 12, 0.93)",
    iconColor: "silver",
    thumbnailBorder: "solid rgb(107, 133, 206) 2px",
    textColor: "silver"
  }
};
var defaultTheme2 = "lightbox";
var Image = (props) => {
  const [backgroundColor, setBackgroundColor] = useState4(props.backgroundColor ? props.backgroundColor : themes2[defaultTheme2].background);
  const [iconColor, setIconColor] = useState4(props.iconColor ? props.iconColor : themes2[defaultTheme2].iconColor);
  const [fullScreen, setFullScreen] = useState4(props.fullScreen ? props.fullScreen : false);
  const [modalCloseOption, setModalCloseOption] = useState4(props.modalClose ? props.modalClose : "default");
  const [disableZoom, setDisableZoom] = useState4(
    props.disableImageZoom ? props.disableImageZoom : false
  );
  const [imageRoundedBorder, setImageRoundedBorder] = useState4(
    props.roundedImages ? props.roundedImages : false
  );
  const [displayFullScreenIcon, setDisplayFullScreenIcon] = useState4(
    props.showFullScreenIcon ? props.showFullScreenIcon : true
  );
  const [className, setClassName] = useState4(
    props.className ? props.className : ""
  );
  const [imgWrapperClass, setImgWrapperClass] = useState4(
    props.wrapperClassName ? props.wrapperClassName : ""
  );
  const [width, setWidth] = useState4(
    props.width ? props.width : null
  );
  const [height, setHeight] = useState4(
    props.height ? props.height : null
  );
  const [lightboxImgClassName, setLightboxImgClassName] = useState4(
    props.lightboxImgClass ? props.lightboxImgClass : ""
  );
  const [imgClass, setImgClass] = useState4(
    props.className ? props.className : ""
  );
  const [displayMagnificationIcons, setDisplayMagnificationIcons] = useState4(
    props.showMagnificationIcons ? props.showMagnificationIcons : true
  );
  const [displayControls, setDisplayControls] = useState4(
    props.showControls ? props.showControls : true
  );
  const [showDownloadBtn, setShowDownloadBtn] = useState4(
    props.downloadImages ? props.downloadImages : false
  );
  const [isRTL, setIsRTL] = useState4(props.rtl ? props.rtl : false);
  const [lightboxIdentifier, setLightboxIdentifier] = useState4(
    props.lightboxIdentifier ? props.lightboxIdentifier : ""
  );
  const [frameworkID, setFrameworkID] = useState4(
    props.framework ? props.framework : ""
  );
  const [images, setImages] = useState4([]);
  const [state, setState] = React2.useState();
  const initProps = () => {
    if (props.showControls != void 0) {
      setDisplayControls(props.showControls);
      setDisableZoom(props.showControls);
      if (props.showControls == false) {
        setDisplayMagnificationIcons(false);
      }
    }
  };
  useEffect3(() => {
    if (props.theme) {
      if (themes2[props.theme]) {
        setBackgroundColor(themes2[props.theme].background);
        setIconColor(themes2[props.theme].iconColor);
      }
    }
    if (props.image && images && images.length == 0 && frameworkID == "next") {
      let imgs = [];
      imgs.push(props.image);
      setImages(imgs);
    } else {
      setImages(null);
    }
    return () => {
    };
  }, [state]);
  const getImage = () => {
    if (frameworkID == "next" && props.children != void 0) {
      return props.children;
    } else if (frameworkID != "next") {
      return /* @__PURE__ */ jsx2(
        "img",
        {
          src: props.image ? props.image.src : "",
          alt: props.image.title,
          width: width != null ? width : "100%",
          height: height != null ? height : "100%",
          className: `${className}`
        }
      );
    }
  };
  useEffect3(() => {
    let isMounted = true;
    if (isMounted)
      initProps();
    return () => {
      isMounted = false;
    };
  }, []);
  return /* @__PURE__ */ jsx2(
    SlideshowLightbox,
    {
      showSlideshowIcon: false,
      showThumbnails: false,
      backgroundColor,
      iconColor,
      theme: props.theme,
      lightboxIdentifier,
      fullScreen,
      showMagnificationIcons: displayMagnificationIcons,
      showFullScreenIcon: displayFullScreenIcon,
      downloadImages: showDownloadBtn,
      roundedImages: imageRoundedBorder,
      disableImageZoom: disableZoom,
      showArrows: false,
      showThumbnailIcon: false,
      showControls: displayControls,
      modalClose: modalCloseOption,
      lightboxImgClass: lightboxImgClassName,
      imgClassName: imgClass,
      imageComponent: true,
      framework: frameworkID,
      imgWrapperClassName: imgWrapperClass,
      images,
      children: getImage()
    }
  );
};

// lib/index.ts
var initLightboxJS = (licenseKey, plan_type) => {
  var body = {
    license_key: licenseKey,
    plan_type
  };
  axios.post("https://lightboxjs-server.herokuapp.com/license", body).then(function(response) {
    let licenseKeyValid = response.data.license_valid;
    if (!licenseKeyValid) {
      console.warn("Lightbox.js: Invalid license key specified, a valid license key must be provided.");
    }
  }).catch(function(error) {
    console.log(error);
  });
};
export {
  Button,
  Image,
  SlideshowLightbox,
  initLightboxJS
};
